<template>
	<div
		class="container-fluid w-full ml-4 vs-con-loading__container"
		id="popupContainer"
		ref="popupContainer"
	>
		<div ref="validationPopupContainer"></div>
		<vs-popup
			title="Modification du client"
			:active.sync="showSocietyModificationAnalyticsPopupActive"
		>
			<div class="vx-row w-full">
				<div class="vx-col">
					<div class="pt-2">Identifiant Analytics :</div>
				</div>
				<div class="vx-col w-1/4">
					<vs-input v-model="modifiedAnalytics" />
				</div>
				<div class="vx-col w-1/4">
					<div class="pl-5">
						<vs-button @click="saveAnalytics">Enregistrer</vs-button>
					</div>
				</div>
				<div class="vx-col w-1/4">
					<vs-button @click="copyDashboardUrlToClipboard"
						>Copier l'adresse à récupérer</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-popup
			title="Modification du client"
			:active.sync="showSocietyModificationGscPopupActive"
		>
			<div class="vx-row w-full">
				<div class="vx-col w-1/4">
					<div class="pt-2">Adresse Search Console :</div>
				</div>
				<div class="vx-col w-1/4">
					<vs-input v-model="modifiedGSC" />
				</div>
				<div class="vx-col w-1/4">
					<div class="pl-5">
						<vs-button @click="saveGsc">Enregistrer</vs-button>
					</div>
				</div>
				<div class="vx-col w-1/4">
					<vs-button @click="copyDashboardUrlToClipboard"
						>Copier l'adresse à récupérer</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-popup
			v-if="conversionPopupActive == true"
			:title="`Détails des objectifs de conversion : ${
				getMonthFrench(
					parseInt(statDateFilter.toDate.substring(5, 7)) - 1
				).toLowerCase() +
				' ' +
				statDateFilter.toDate.substring(0, 4)
			}`"
			:active.sync="conversionPopupActive"
		>
			<vs-tabs>
				<vs-tab :label="`Mois actuel`">
					<vs-table
						stripe
						hoverFlat
						auto-resize
						pagination
						max-items="18"
						noDataText=""
						:data="actualMonthConversion"
					>
						<template slot="thead">
							<vs-th class="text-center" sort-key="name">Objectif</vs-th>
							<vs-th sort-key="position">Nb. de conversions</vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr :key="index" v-for="(row, index) of data">
								<vs-td>
									<strong>{{ row.name }}</strong>
								</vs-td>
								<vs-td class="txt_align_right">
									{{ row.value }}
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
				<vs-tab label="Mois dernier">
					<vs-table
						stripe
						hoverFlat
						auto-resize
						pagination
						max-items="18"
						noDataText=""
						:data="lastMonthConversion"
					>
						<template slot="thead">
							<vs-th class="text-center" sort-key="name">Objectif</vs-th>
							<vs-th sort-key="position">Nb. de conversions</vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr :key="index" v-for="(row, index) of data">
								<vs-td>
									<strong>{{ row.name }}</strong>
								</vs-td>
								<vs-td class="txt_align_right">
									{{ row.value }}
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
			</vs-tabs>
		</vs-popup>
		<vs-popup
			v-if="transactionPopupActive == true"
			:title="`Détails des transactions par produit : ${
				getMonthFrench(
					parseInt(statDateFilter.toDate.substring(5, 7)) - 1
				).toLowerCase() +
				' ' +
				statDateFilter.toDate.substring(0, 4)
			}`"
			:active.sync="transactionPopupActive"
		>
			<vs-tabs>
				<vs-tab :label="`Mois actuel`">
					<vs-table
						stripe
						hoverFlat
						auto-resize
						pagination
						max-items="18"
						noDataText=""
						:data="actualMonthSoldItems"
					>
						<template slot="thead">
							<vs-th class="text-center" sort-key="product">Produit</vs-th>
							<vs-th sort-key="value">Prix Unitaire HT</vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr :key="index" v-for="(row, index) of data">
								<vs-td>
									<strong>{{ row.product }}</strong>
								</vs-td>
								<vs-td class="txt_align_right"> {{ row.value }}€ </vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
				<vs-tab label="Mois dernier">
					<vs-table
						stripe
						hoverFlat
						auto-resize
						pagination
						max-items="18"
						noDataText=""
						:data="lastMonthSoldItems"
					>
						<template slot="thead">
							<vs-th class="text-center" sort-key="product">Produit</vs-th>
							<vs-th sort-key="value">Prix Unitaire HT</vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr :key="index" v-for="(row, index) of data">
								<vs-td>
									<strong>{{ row.product }}</strong>
								</vs-td>
								<vs-td class="txt_align_right"> {{ row.value }}€ </vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
			</vs-tabs>
		</vs-popup>
		<vs-popup
			v-if="evolutionPopupActive == true"
			:title="
				'Evolution des positions du Top Keyword : ' + selectedEvolutionKeyword
			"
			:active.sync="evolutionPopupActive"
		>
			<TopKeywordEvolutionTable
				:selectedTopKeywordsSERPComparison="selectedTopKeywordsSERPComparison"
				:societyColor="this.colors[0]"
				:competitorsColor="this.competitorsColor"
			/>
		</vs-popup>
		<vs-popup
			v-if="lineChartPopupBool == true"
			title="Performance du Keyword sur la période"
			:active.sync="lineChartPopupBool"
		>
			<apexchart
				v-if="
					lineChartPopup && lineChartPopup.chartOptions && lineChartPopup.series
				"
				ref="popupDataChartTopKeywords"
				type="area"
				height="350"
				width="800"
				:options="lineChartPopup.chartOptions"
				:series="lineChartPopup.series"
			></apexchart>
		</vs-popup>
		<vs-popup :active.sync="keywordListPopup" title="Listing des keywords">
			<KeywordListTable
				v-if="keywordData && selectedDate"
				:data="keywordData[selectedDate.year][selectedDate.monthIndex]"
			/>
		</vs-popup>
		<vs-popup
			v-if="keywordsDiffPopup == true"
			:active.sync="keywordsDiffPopup"
			title="Listing de la différence des keywords"
		>
			<vs-tabs>
				<vs-tab label="Nouveaux mots-clés">
					<KeywordListTable
						v-if="keywordsDiffPopupDataNew"
						:data="keywordsDiffPopupDataNew"
						:withvolumecpc="true"
					/>
				</vs-tab>
				<vs-tab label="Mots-clés Perdus">
					<KeywordListTable
						v-if="keywordsDiffPopupDataDelete"
						:data="keywordsDiffPopupDataDelete"
						:withvolumecpc="true"
					/>
				</vs-tab>
			</vs-tabs>
		</vs-popup>
		<vs-popup
			v-if="topKeywordListPopup == true"
			:active.sync="topKeywordListPopup"
			title="Listing des top keywords"
		>
			<KeywordListTable
				v-if="topKeywordListing && topKeywordListing.length > 0 && selectedDate"
				:data="topKeywordListing"
			/>
		</vs-popup>

		<div v-if="selectedSociety">
			<!-- COLUMN STACKED CHART -->
			<div v-if="$acl.check('accountmanager')" class="vx-row w-full mb-base">
				<TopKeywordsFilter
					ref="topKeywordsFilter"
					:topKeywords="topKeywords"
					:competitors="competitors"
					:brands="brands"
					:society="selectedSociety"
					:apiLastUpdate="apiLastUpdate"
					:last_update="last_update"
					@refresh-data="refreshGSCData()"
					@update-api-date="updateApiDate($event)"
					@updated-top-keywords="updateTopKeywords($event)"
					@updated-competitors="updateCompetitors($event)"
					@updated-brands="updateBrands($event)"
					@launch-loader="openLoading()"
					@stop-loader="closeLoading()"
				/>
			</div>
			<div
				class="vx-row w-full mb-base"
				v-if="
					(haveGscAccess == true && keywordListingFull.data.length <= 0) ||
					haveGscAccess == false ||
					haveAnalyticsAccess == false ||
					(topKeywords && topKeywords.length <= 0)
				"
			>
				<vx-card>
					<ul>
						<li v-if="haveGscAccess == false">
							<span class="vx-row">
								<span class="vx-col"
									><vs-icon icon="warning" size="small" color="primary"
								/></span>
								<span class="vx-col"
									>Attention, nous n'avons pas accès à votre compte Google
									Search Console. Veuillez contacter votre référent Rankwell. </span
								><span
									v-if="$acl.check('accountmanager')"
									@click="showSocietyModificationGscPopup"
									class="hvr-underline hvr-underline-out"
									>(Modifier le client)</span
								>
							</span>
						</li>
						<li
							v-if="
								haveGscAccess == true && keywordListingFull.data.length <= 0
							"
						>
							<span class="vx-row">
								<span class="vx-col"
									><vs-icon icon="warning" size="small" color="primary"
								/></span>
								<span class="vx-col"
									>Attention, nous avons accès à votre compte Google Search
									Console, mais il ne remonte pas de données. Veuillez contacter
									votre référent Rankwell. </span
								><span
									v-if="$acl.check('accountmanager')"
									@click="showSocietyModificationGscPopup"
									class="hvr-underline hvr-underline-out"
									>(Modifier le client)</span
								>
							</span>
						</li>
						<li v-if="haveAnalyticsAccess == false">
							<span class="vx-row">
								<span class="vx-col"
									><vs-icon icon="warning" size="small" color="primary"
								/></span>
								<span class="vx-col"
									>Attention, nous n'avons pas les droits suffisants pour votre
									compte Google Analytics. Veuillez contacter votre référent
									Rankwell. </span
								><span
									v-if="$acl.check('accountmanager')"
									@click="showSocietyModificationAnalyticsPopup"
									class="hvr-underline hvr-underline-out"
									>(Modifier le client)</span
								>
							</span>
						</li>
						<li v-if="topKeywords && topKeywords.length <= 0">
							<span class="vx-row">
								<span class="vx-col"
									><vs-icon icon="warning" size="small" color="primary"
								/></span>
								<span class="vx-col"
									>Attention vous n'avez pas défini de top keywords.
									<span
										v-if="$acl.check('accountmanager')"
										@click="showTopKeywordsPopup"
										style="width: 37px"
										class="hvr-underline hvr-underline-out"
										>(Editer les top keywords)</span
									></span
								>
							</span>
						</li>
					</ul>
				</vx-card>
			</div>
			<vs-tabs ref="mainTabs">
				<vs-tab label="Général">
					<KeywordsGeneral
						ref="keywordsGeneral"
						:keywordDataLength="
							keywordData ? Object.keys(keywordData).length : 0
						"
						:topKeywordsLength="topKeywords.length"
						:societyIsEcommerce="selectedSociety.is_ecommerce"
						:seoValueByKeywordPreviousMonthWarning="
							seoValueByKeywordPreviousMonthWarning
						"
						:toDate="statDateFilter.toDate"
						:keywordNumberEvolution="keywordNumberEvolution"
						:averagePositionEvolution="averagePositionEvolution"
						:seoValueEvolution="seoValueEvolution"
						:revenueEvolution="revenueEvolution"
						:conversionEvolution="conversionEvolution"
						:perfDataKeywordsAreaChart="perfDataKeywordsAreaChart"
						:stackedColumnChartOptionTopKeywords="
							stackedColumnChartOptionTopKeywords
						"
						:stackedColumnChartOptionKeywords="stackedColumnChartOptionKeywords"
						:topKeywordsSEOValue="topKeywordsSEOValue"
						:topKeywordsSEOValueByKeyword="topKeywordsSEOValueByKeyword"
						:pageNumberOptions="pageNumberOptions"
						@show-keywords-diff="showKeywordsDiffPopup"
						@show-transactions-diff="displayTransactionPopup"
						@show-conversions-diff="displayConversionPopup"
					/>
				</vs-tab>
				<vs-tab label="Search Console">
					<KeywordsSearchConsole
						v-if="isMainActiveTab('1')"
						ref="keywordsSearchConsole"
						:apiUrl="apiUrl"
						:fromDate="fromDate"
						:toDate="toDate"
						:globalSiteData="globalSiteData"
						:globalSiteDataKeywords="globalSiteDataKeywords"
						:globalDataAreaChartKeywords="globalDataAreaChartKeywords"
						:globalDataAreaChartTopKeywords="globalDataAreaChartTopKeywords"
						:keywordListingFull="keywordListingFull"
						:topKeywordListingFull="topKeywordListingFull"
						:keywordDataLength="
							keywordData ? Object.keys(keywordData).length : 0
						"
						:perfTitle="perfTitle"
						:pageNumberOptions="pageNumberOptions"
						:topKeywords="topKeywords"
						:brands="brands"
						:societyId="selectedSociety.id"
						@add-brand="addBrandValidation($event)"
						@remove-brand="removeBrandValidation($event)"
						@add-top-keyword="addTopKeywordValidation($event)"
						@remove-top-keyword="removeTopKeywordValidation($event)"
						@show-line-chart-popup="showLineChartPopup($event)"
					/>
				</vs-tab>
				<vs-tab label="Concurrents">
					<KeywordsCompetitors
						v-if="isMainActiveTab('2')"
						ref="keywordsCompetitors"
						:competitorsLength="competitors.length"
						:topKeywordsLength="topKeywords.length"
						:maxRowMultiplicatorTKSERP="maxRowMultiplicatorTKSERP"
						:totalPageTKSERP="totalPageTKSERP"
						:seoValueByKeywordPreviousMonthWarning="
							seoValueByKeywordPreviousMonthWarning
						"
						:societyName="selectedSociety.name"
						:stackedBarChartOptionsTopKeywordsCompetitorsComparison="
							stackedBarChartOptionsTopKeywordsCompetitorsComparison
						"
						:topKeywordsSEOValueOptions="topKeywordsSEOValueOptions"
						:filteredtopKeywordsSERPComparison="
							filteredtopKeywordsSERPComparison
						"
						:totalRowTKSERP="totalRowTKSERP"
						:totalVolumeFilteredKeywordsCompetitors="
							totalVolumeFilteredKeywordsCompetitors
						"
						:pageNumberOptions="pageNumberOptions"
						:competitors="competitors"
						:competitorsFavicon="competitorsFavicon"
						:societyFavicon="societyFavicon"
						:serpComparisonSortKey="serpComparisonSortKey"
						:serpComparisonSortType="serpComparisonSortType"
						@update-competitor-table-value="currentPageTKSERP = $event"
						@show-competitor-popup="showCompetitorsPopup"
						@select-evolution-keyword="selectEvolutionKeyword"
						@update-keyword-search-input="setKeywordSearchInput($event)"
						@update-max-row-multiplicator-tk-serp="
							setMaxRowMultiplicatorTKSERP($event)
						"
						@update-competitors-table-sort="updateCompetitorsTableSort"
					/>
				</vs-tab>
				<vs-tab label="Notoriété de la Marque">
					<KeywordsFame
						v-if="isMainActiveTab('3')"
						ref="keywordsFame"
						:brandsLength="brands.length"
						:pageRankDataLength="pageRankData.length"
						:societyName="selectedSociety.name"
						:showBrandsPopup="showBrandsPopup"
						:brandDataTotal="brandDataTotal"
						:globalSiteDataKeywords="globalSiteDataKeywords"
						:genericPosition="genericPosition"
						:genericCTR="genericCTR"
						:stackedColumnChartOptionBrandTraffic="
							stackedColumnChartOptionBrandTraffic
						"
						:impComparisonChartOptions="impComparisonChartOptions"
						:pageNumberOptions="pageNumberOptions"
						:brandKeywordsListing="brandKeywordsListing"
						:brandPageRankData="brandPageRankData"
					/>
				</vs-tab>
			</vs-tabs>
		</div>
		<div v-else>
			<div class="vx-row w-full">
				<vx-card>
					<h2>
						Veuillez sélectionner une société en utilisant la barre de
						navigation horizontale en haut de la page.
					</h2>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import store from "@/store/store";
import { Society } from "@/entities/Society";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup.vue";
import TopKeywordsFilter from "@/components/tables/TopKeywordsFilter.vue";
import KeywordsGeneral from "@/components/views/dashboard/keywords/KeywordsGeneral.vue";
import KeywordsSearchConsole from "@/components/views/dashboard/keywords/KeywordsSearchConsole.vue";
import KeywordsCompetitors from "@/components/views/dashboard/keywords/KeywordsCompetitors.vue";
import KeywordsFame from "@/components/views/dashboard/keywords/KeywordsFame.vue";
import ValidationPopup from "@/components/popups/ValidationPopup.vue";

import KeywordListTable from "@/components/tables/KeywordListTable.vue";
import TopKeywordEvolutionTable from "@/components/tables/TopKeywordEvolutionTable.vue";
/*
 * CUSTOM COMPONENTS
 * MIXINS
 */
import utilsMixin from "@/mixins/utilsMixin";
import sortingMixin from "@/mixins/sortingMixin";
import chartsMixin from "@/mixins/chartsMixin";

export default {
	name: "KeywordsStatistics",
	mixins: [utilsMixin, sortingMixin, chartsMixin],
	components: {
		TopKeywordsFilter,
		KeywordListTable,
		TopKeywordEvolutionTable,
		KeywordsGeneral,
		KeywordsSearchConsole,
		KeywordsCompetitors,
		KeywordsFame,
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			society: null,
			loading: false,
			firstLoading: false,
			colors: [
				"#08B0B9",
				"#2E93fA",
				"#66DA26",
				"#546E7A",
				"#E91E63",
				"#FF9800",
				"#9e90d3",
				"#8ebd9d",
				"#ebab92",
				"#5a7268",
			],
			colorsStack: [
				"#000000",
				"#97f8fc",
				"#75eaf0",
				"#0bd6e0",
				"#08B0B9",
				"#FFC90E",
			],
			colorsStackCompetitors: [
				"#000000",
				"#97f8fc",
				"#75eaf0",
				"#0bd6e0",
				"#08B0B9",
				"#470D93",
			],
			societyFavicon: null,
			keywordSearchInput: "",
			pageSearchInput: "",
			haveGscAccess: false,
			haveAnalyticsAccess: false,

			modifiedAnalytics: "",
			modifiedGSC: "",

			// LOADER DATA
			loadersIds: {
				refreshBrandsPages: {
					data: ["brand-page-clicks"],
					position: ["keywordsFame"],
					noslug: ["brandpageclicks"],
					status: false,
				},
				// refreshKeywordData -> getKeywordData ; getDataPerDateKeywords ; setStackedBarChartOptionsKeywords ; getBrandData ; getTopKeywordData ; getTopKeywordData
				refreshKeywordData: {
					data: [
						"rc-positions",
						"apex-stacked-keywords",
						"gsc-keywords",
						"gsc-top-keywords",
					],
					position: [
						"keywordsGeneral",
						"keywordsGeneral",
						"keywordsSearchConsole",
						"keywordsSearchConsole",
					],
					noslug: [
						"rcpositions",
						"apexstackedkeywords",
						"gsckeywords",
						"gsctopkeywords",
					],
					status: false,
				},
				// refreshTopKeywords -> getTopKeywords ; getTopKeywordData
				refreshTopKeywords: {
					data: [
						"table-perf-top-keywords",
						"apex-stacked-top-keywords",
						"rc-top-keywords",
						"rc-positions",
						"rc-seo-value",
						"gsc-top-keywords",
						"competitor-compared-positions",
						"competitor-seo-value",
					],
					position: [
						"keywordsGeneral",
						"keywordsGeneral",
						"keywordsGeneral",
						"keywordsGeneral",
						"keywordsGeneral",
						"keywordsSearchConsole",
						"keywordsCompetitors",
						"keywordsCompetitors",
					],
					noslug: [
						"tableperftopkeywords",
						"apexstackedtopkeywords",
						"rctopkeywords",
						"rcpositions",
						"rcseovalue",
						"gsctopkeywords",
						"competitorcomparedpositions",
						"competitorseovalue",
					],
					status: false,
				},
				// refreshBrands -> getBrands ; getBrandData
				refreshBrands: {
					data: [
						"brand-page-clicks",
						"brand-rc-impressions",
						"brand-rc-clicks",
						"brand-rc-average-position",
						"brand-rc-ctr",
						"brand-stacked-traffic",
						"brand-imp-comparison",
						"brand-listing-keywords",
					],
					position: [
						"keywordsFame",
						"keywordsFame",
						"keywordsFame",
						"keywordsFame",
						"keywordsFame",
						"keywordsFame",
						"keywordsFame",
						"keywordsFame",
					],
					noslug: [
						"brandpageclicks",
						"brandrcimpressions",
						"brandrcclicks",
						"brandrcaverageposition",
						"brandrcctr",
						"brandstackedtraffic",
						"brandimpcomparison",
						"brandlistingkeywords",
					],
					status: false,
				},
				// refreshCompetitors -> getCompetitorsFavicon ; buildTopKeywordsSERPComparison
				refreshCompetitors: {
					data: [
						"competitor-compared-positions",
						"competitor-seo-value",
						"competitor-positions-evolution",
					],
					position: [
						"keywordsCompetitors",
						"keywordsCompetitors",
						"keywordsCompetitors",
					],
					noslug: [
						"competitorcomparedpositions",
						"competitorseovalue",
						"competitorpositionsevolution",
					],
					status: false,
				},
				refreshIndependentData: {
					data: ["rc-organic-revenue", "rc-organic-conversion"],
					position: ["keywordsGeneral", "keywordsGeneral"],
					noslug: ["rcorganicrevenue", "rcorganicconversion"],
					status: false,
				},
			},

			loaderStatus: {
				rctopkeywords: [],
				rcpositions: [],
				rcseovalue: [],
				rcorganicrevenue: [],
				rcorganicconversion: [],
				apexstackedtopkeywords: [],
				apexstackedkeywords: [],
				gsckeywords: [],
				gsctopkeywords: [],
				competitorcomparedpositions: [],
				competitorseovalue: [],
				competitorpositionsevolution: [],
				brandpageclicks: [],
				brandrcimpressions: [],
				brandrcclicks: [],
				brandrcaverageposition: [],
				brandrcctr: [],
				brandstackedtraffic: [],
				brandimpcomparison: [],
				brandlistingkeywords: [],
				tableperftopkeywords: [],
			},

			// POPUP DATA
			selectedEvolutionKeyword: null,
			evolutionPopupActive: false,

			conversionPopupActive: false,
			transactionPopupActive: false,

			lineChartPopupBool: false,
			lineChartPopup: null,

			keywordListPopup: false,
			topKeywordListPopup: false,

			keywordsDiffPopup: false,
			keywordsDiffPopupDataNew: [],
			keywordsDiffPopupDataDelete: [],

			topKeywordListing: [],

			brandKeywordsListing: [],
			brandKeywordsListingMaxRow: 10,

			showSocietyPopupActive: false,
			showSocietyModificationAnalyticsPopupActive: false,
			showSocietyModificationGscPopupActive: false,

			brandValidationPopup: false,
			brandValidationValue: {},

			topKeywordValidationPopup: false,
			topKeywordValidationValue: {},

			boolValidationPopup: false,
			titleValidationPopup: "",
			valueValidationPopup: null,
			acceptValidationFunction: function () {},
			declineValidationFunction: function () {},
			// DATE DATA
			selectedDate: null,
			fromDate: null,
			toDate: null,

			apiLastUpdate: {
				gsc: null,
				ads: null,
				georanker: null,
			},
			last_update: "",

			today: new Date(Date.now()).toISOString().slice(0, 10),

			// STATISTIC CARDS
			keywordNumberEvolution: {
				color: "",
				value: 0,
				icon: "",
				itext: "X",
				statistics: "-",
			},

			averagePositionEvolution: {
				color: "grey",
				value: 0,
				icon: "",
				itext: "X",
				statistics: "-",
			},

			seoValueEvolution: {
				color: "",
				value: 0,
				icon: "",
				itext: "X",
				statistics: "-",
			},

			revenueEvolution: {
				color: "",
				value: 0,
				icon: "",
				itext: "X",
				statistics: "-",
			},

			conversionEvolution: {
				color: "",
				value: 0,
				icon: "",
				itext: "X",
				statistics: "-",
			},

			// CHECKBOX DATA
			oneYearAgo: false,
			sixMonthsAgo: false,

			themeColors: ["#28C76F", "#7367F0", "#EA5455", "#FF9F43", "#1E1E1E"],

			// RANK PER PAGE
			pageRankData: [], // STORE DATA FROM GOOGLE APIS
			brandPageRankData: [], // STORE DATA FROM GOOGLE APIS
			pagesRankDataNumberShown: 10,
			pageNumberOptions: [5, 10, 25, 50, 100],

			// GLOBAL DATA
			globalSiteData: [], // STORE DATA FROM GOOGLE APIS
			globalTotalPos: 0,
			globalKeywordLength: 0,
			globalSiteDataKeywords: [],
			globalDataAreaChartKeywords: null,
			globalDataAreaChartTopKeywords: null,

			// PERF DATA CHART
			perfDataKeywords: null,
			perfDataKeywordsAreaChart: null,

			// ???
			globalDataPerDate: [], // STORE DATA FROM GOOGLE APIS -> A EFFACER

			// STACKED BAR TOP POSITIONS
			stackedColumnChartOptionTopKeywords: null, // CHARTS DATA
			stackedColumnChartOptionKeywords: null, // CHARTS DATA
			stackedColumnChartOptionBrandTraffic: null,
			stackedBarChartOptionsTopKeywordsCompetitorsComparison: null,
			stackedColumnChartOptionBrandTrafficSeriesAndXaxis: null,

			// VALEUR DU SEO
			topKeywordsSEOValueByKeyword: [],
			seoValueByKeywordPreviousMonthWarning: false,
			topKeywordsSEOValueOptions: null,
			topKeywordsSEOValue: [],
			keywordsSEOValueOptions: null,
			keywordsSEOValue: [],
			lastMonthSeoValue: 0,

			// KEYWORDS / TOP KEYWORDS DATA
			impComparisonChartOptions: null,
			keywordData: [], // STORE DATA FROM GOOGLE APIS
			keywordListingFull: {
				data: [],
				date: "",
			},

			topKeywords: [],
			topKeywordData: {},
			topKeywordListingFull: {
				data: [],
				date: "",
			},
			topKeywordMergedData: [],
			allCtrAverages: {},
			//Ads
			topKeywordHistData: [],

			//Top Keywords comparison by keyword
			topKeywordsSERPComparison: {},
			currentPageTKSERP: 1,
			maxRowMultiplicatorTKSERP: 25, // multiplicateur * (competitor + 2) * Shown Keyword Number
			totalRowTKSERP: 0,
			serpComparisonSortKey: null,
			serpComparisonSortType: null,
			totalVolumeFilteredKeywordsCompetitors: 0,

			//Competitors
			competitors: [],
			competitorsColor: [],
			competitorsFavicon: [],
			competitorsId: [],
			competitorsName: [],

			//Brands
			brands: [],
			brandData: {},
			brandsPagesData: [],
			brandDataTotal: {
				clicks: 0,
				impressions: 0,
				ctr: 0.0,
				position: 0,
			},

			//Generic
			genericPosition: 0,
			genericCTR: 0,

			//Revenues (Analytics)
			actualMonthRevenue: 0,
			actualMonthSoldItems: [],
			lastMonthRevenue: 0,
			lastMonthSoldItems: [],

			//Conversions (Analytics)
			actualMonthConversion: null,
			actualMonthConversionTotal: 0,
			lastMonthConversion: null,
			lastMonthConversionTotal: 0,
		};
	},

	created() {
		this.fromDate = this.statDateFilter.fromDate;
		this.toDate = this.statDateFilter.toDate;
		this.compareFromDate = this.statDateFilter.compareFromDate;
		this.compareFromDateShow = this.statDateFilter.compareFromDateShow;
		this.compareToDate = this.statDateFilter.compareToDate;
		this.compareToDateShow = this.statDateFilter.compareToDateShow;
		this.oneYearAgo = this.statDateFilter.oneYearAgo;
		this.sixMonthsAgo = this.statDateFilter.sixMonthsAgo;
		if (this.selectedSociety) {
			this.openLoading();
			this.refreshAllData().then(() => {
				this.closeLoading();
			});
		}
	},

	computed: {
		perfTitle() {
			return (
				"Performances cumulées des Keywords et Top Keywords du " +
				this.fromDate.split("-").reverse().join("/") +
				" au " +
				this.toDate.split("-").reverse().join("/")
			);
		},
		selectedSociety() {
			return this.$store.state.activeUserSociety;
		},
		statDateFilter() {
			return this.$store.state.statDateFilter;
		},
		filteredtopKeywordsSERPComparison() {
			console.time("filteredtopKeywordsSERPComparison");
			if (
				this.topKeywordsSERPComparison.keywords &&
				Object.entries(this.topKeywordsSERPComparison.keywords).length > 0
			) {
				let filtered = {
					dates: this.topKeywordsSERPComparison.dates,
					keywords: {},
					keywords_info: {},
					domains: [],
				};
				let sortedKeywordsEntries = Object.entries(
					this.topKeywordsSERPComparison.keywords
				);

				if (this.keywordSearchInput != "") {
					sortedKeywordsEntries = sortedKeywordsEntries.map((entry) => {
						if (entry[0].includes(this.keywordSearchInput)) {
							return entry;
						}
					});
					sortedKeywordsEntries = sortedKeywordsEntries.filter((entry) => {
						if (entry) return entry;
					});
				}

				const keyAssociation = {
					keyword: "keywords",
					cpc: "keywords_info",
					volume: "keywords_info",
					kd: "keywords_info",
				};

				if (this.serpComparisonSortType) {
					let dataKey = keyAssociation[this.serpComparisonSortKey]
						? keyAssociation[this.serpComparisonSortKey]
						: "keywords";

					sortedKeywordsEntries.sort((a, b) => {
						let comparison = 0;
						if (dataKey == "keywords_info") {
							if (
								this.topKeywordsSERPComparison[dataKey][a[0]] &&
								this.topKeywordsSERPComparison[dataKey][b[0]]
							) {
								if (
									this.topKeywordsSERPComparison[dataKey][a[0]][
										this.serpComparisonSortKey
									] <
									this.topKeywordsSERPComparison[dataKey][b[0]][
										this.serpComparisonSortKey
									]
								) {
									comparison = 1;
								} else if (
									this.topKeywordsSERPComparison[dataKey][a[0]][
										this.serpComparisonSortKey
									] >
									this.topKeywordsSERPComparison[dataKey][b[0]][
										this.serpComparisonSortKey
									]
								) {
									comparison = -1;
								}
							}
						} else if (dataKey == "keywords") {
							if (
								this.topKeywordsSERPComparison[dataKey][a[0]] &&
								this.topKeywordsSERPComparison[dataKey][b[0]]
							) {
								if (this.serpComparisonSortKey == "keyword") {
									if (a[0] < b[0]) {
										comparison = 1;
									} else if (a[0] > b[0]) {
										comparison = -1;
									}
								} else {
									let lastDateIndex =
										this.topKeywordsSERPComparison.dates.length - 1;
									let valueA = this.topKeywordsSERPComparison[dataKey][a[0]][
										this.serpComparisonSortKey
									]
										? this.topKeywordsSERPComparison[dataKey][a[0]][
												this.serpComparisonSortKey
										  ][lastDateIndex]
										: 101;
									let valueB = this.topKeywordsSERPComparison[dataKey][b[0]][
										this.serpComparisonSortKey
									]
										? this.topKeywordsSERPComparison[dataKey][b[0]][
												this.serpComparisonSortKey
										  ][lastDateIndex]
										: 101;

									valueA = valueA == 0 ? 100 : valueA;
									valueB = valueB == 0 ? 100 : valueB;
									valueA = valueA == -1 ? 101 : valueA;
									valueB = valueB == -1 ? 101 : valueB;
									if (valueA < valueB) {
										comparison = 1;
									} else if (valueA > valueB) {
										comparison = -1;
									}
								}
							}
						}

						if (this.serpComparisonSortType == "asc") {
							comparison = comparison * -1;
						}

						return comparison;
					});
				} else {
					sortedKeywordsEntries.sort((a, b) => {
						let comparison = 0;
						if (
							this.topKeywordsSERPComparison.keywords_info[a[0]] &&
							this.topKeywordsSERPComparison.keywords_info[b[0]]
						) {
							if (
								this.topKeywordsSERPComparison.keywords_info[a[0]].volume <
								this.topKeywordsSERPComparison.keywords_info[b[0]].volume
							) {
								comparison = 1;
							} else if (
								this.topKeywordsSERPComparison.keywords_info[a[0]].volume >
								this.topKeywordsSERPComparison.keywords_info[b[0]].volume
							) {
								comparison = -1;
							}
						}
						return comparison;
					});
				}

				this.totalRowTKSERP =
					sortedKeywordsEntries.length > 0 ? sortedKeywordsEntries.length : 0;

				// currentPageTKSERP
				let iterationCounter = 0;
				let iterationStart =
					(this.currentPageTKSERP - 1) * this.maxRowMultiplicatorTKSERP;
				let pageMultiplicator = iterationStart + this.maxRowMultiplicatorTKSERP;
				for (const [key, value] of sortedKeywordsEntries) {
					if (
						iterationCounter < pageMultiplicator &&
						iterationCounter >= iterationStart
					) {
						filtered.keywords[key] = value;
					}
					iterationCounter = iterationCounter + 1;
				}

				for (let key in filtered.keywords) {
					filtered.keywords_info[key] =
						this.topKeywordsSERPComparison.keywords_info[key];
				}

				let totalVolume = 0;
				if (Object.keys(filtered.keywords_info).length > 0) {
					for (let key in filtered.keywords_info) {
						totalVolume += filtered.keywords_info[key].volume;
					}
				}

				this.totalVolumeFilteredKeywordsCompetitors = totalVolume;

				for (let domain of this.topKeywordsSERPComparison.domains) {
					filtered.domains.push(domain);
				}
				console.timeEnd("filteredtopKeywordsSERPComparison");
				return filtered;
			} else {
				console.timeEnd("filteredtopKeywordsSERPComparison");
				return {
					dates: [],
					keywords: {},
					keywords_info: {},
				};
			}
		},

		selectedTopKeywordsSERPComparison() {
			console.time("filteredtopKeywordsSERPComparison");
			if (
				this.topKeywordsSERPComparison.keywords &&
				Object.entries(this.topKeywordsSERPComparison.keywords).length > 0
			) {
				let filtered = {
					dates: this.topKeywordsSERPComparison.dates,
					keywords: {},
					keywords_info: {},
				};
				if (
					this.topKeywordsSERPComparison.keywords[this.selectedEvolutionKeyword]
				) {
					filtered.keywords[this.selectedEvolutionKeyword] =
						this.topKeywordsSERPComparison.keywords[
							this.selectedEvolutionKeyword
						];
				}

				if (
					this.topKeywordsSERPComparison.keywords_info[
						this.selectedEvolutionKeyword
					]
				) {
					filtered.keywords_info[this.selectedEvolutionKeyword] =
						this.topKeywordsSERPComparison.keywords_info[
							this.selectedEvolutionKeyword
						];
				}
				console.timeEnd("filteredtopKeywordsSERPComparison");
				return filtered;
			} else {
				console.timeEnd("filteredtopKeywordsSERPComparison");
				return {
					dates: [],
					keywords: {},
					keywords_info: {},
				};
			}
		},
		maxRowTKSERP() {
			// multiplicateur * (competitor + 2) * Shown Keyword Number
			return this.competitors
				? this.maxRowMultiplicatorTKSERP * (this.competitors.length + 2)
				: this.maxRowMultiplicatorTKSERP * 2;
		},
		totalPageTKSERP() {
			// Total row() / maxRowTKSERP
			return this.totalRowTKSERP > 0
				? Math.ceil(this.totalRowTKSERP / this.maxRowMultiplicatorTKSERP)
				: 0;
		},
	},
	watch: {
		stackedColumnChartOptionTopKeywords: function () {
			window.dispatchEvent(new Event("resize"));
		},
		stackedColumnChartOptionKeywords: function () {
			window.dispatchEvent(new Event("resize"));
		},
		stackedColumnChartOptionBrandTraffic: function () {
			window.dispatchEvent(new Event("resize"));
		},
		keywordsSEOValueOptions: function () {
			window.dispatchEvent(new Event("resize"));
		},
		topKeywordsSEOValueOptions: function () {
			window.dispatchEvent(new Event("resize"));
		},
		perfDataKeywordsAreaChart: function () {
			window.dispatchEvent(new Event("resize"));
		},
		selectedSociety: function () {
			// Clear data
			if (this.$refs.keywordsSearchConsole) {
				this.$refs.keywordsSearchConsole.resetMarque();
			}
			if (this.$refs.topKeywordsFilter) {
				this.$refs.topKeywordsFilter.resetPopup();
			}
			this.clearData();
			this.openLoading();
			this.refreshAllData().then(() => {
				this.closeLoading();
			});
		},
		pageSearchInput: function (data) {
			this.$refs.pageRankDataTable.searchx = data;
		},

		statDateFilter: function (data) {
			this.fromDate = data.fromDate;
			this.toDate = data.toDate;
			this.compareFromDate = data.compareFromDate;
			this.compareFromDateShow = data.compareFromDateShow;
			this.compareToDate = data.compareToDate;
			this.compareToDateShow = data.compareToDateShow;
			this.oneYearAgo = data.oneYearAgo;
			this.sixMonthsAgo = data.sixMonthsAgo;

			this.refreshAllData();
		},
		loading: function (data) {
			if (data == false) {
				this.$vs.loading.close("#popupContainer > .con-vs-loading");
			}
		},
		firstLoading: function () {},
		brandDataTotal: {
			deep: true,
			handler: function (data) {
				this.getImpComparisonChartOptions(data);
			},
		},
		loaderStatus: {
			deep: true,
			handler: function () {
				// //console.log("loader watcher: ", data)
			},
		},
	},
	methods: {
		/*
		 * 0001 - Tools
		 * 0002 - Get
		 * 0003 - Display / Show
		 * 0004 - Refresh
		 * 0005 - Update
		 * 0006 - Build
		 * 0007 - Set
		 */

		// 0001 - Tools
		copyDashboardUrlToClipboard() {
			// Url.text = "dashboard-service-account@dashboard-1603872171362.iam.gserviceaccount.com";
			const el = document.createElement("textarea");
			el.value =
				"dashboard-service-account@dashboard-1603872171362.iam.gserviceaccount.com";
			el.setAttribute("readonly", "");
			el.style.position = "absolute";
			el.style.left = "-9999px";
			document.body.appendChild(el);
			const selected =
				document.getSelection().rangeCount > 0
					? document.getSelection().getRangeAt(0)
					: false;
			el.select();
			document.execCommand("copy");
			document.body.removeChild(el);
			if (selected) {
				document.getSelection().removeAllRanges();
				document.getSelection().addRange(selected);
			}
			this.$vs.notify({
				title: "Succès",
				text: "Adresse copiée dans le presse-papier.",
			});
		},

		isTopKeyword(keyword) {
			return this.topKeywords.includes(keyword);
		},
		isBrand(keyword) {
			return this.brands.includes(keyword);
		},
		getPotentialModifierForKeyword(keyword) {
			if (this.isTopKeyword(keyword)) return 3;
			if (this.isBrand(keyword)) return 0;
			return 1;
		},
		openLoadingContainer(containerId) {
			this.$vs.loading({
				container: containerId,
				scale: 0.6,
			});
		},
		closeLoadingContainer(containerId) {
			// CHECK IF LOADER IS OPEN

			// IF YES CLOSE
			this.$vs.loading.close(containerId);
		},
		clearData() {
			// STATISTIC CARDS
			this.keywordNumberEvolution = {
				color: "grey",
				value: 0,
				icon: "",
				itext: "X",
				statistics: "-",
			};

			this.averagePositionEvolution = {
				color: "grey",
				value: 0,
				icon: "",
				itext: "X",
				statistics: "-",
			};
			// RANK PER PAGE
			this.pageRankData = [];
			this.brandPageData = [];

			// GLOBAL DATA
			this.globalSiteData = [];
			this.globalSiteDataKeywords = [];
			this.globalDataAreaChartKeywords = null;
			this.globalDataAreaChartTopKeywords = null;

			// STACKED BAR TOP POSITIONS
			this.stackedColumnChartOptionTopKeywords = null; // CHARTS DATA
			this.stackedColumnChartOptionKeywords = null; // CHARTS DATA
			this.stackedColumnChartOptionBrandTraffic = null;
			this.stackedBarChartOptionsTopKeywordsCompetitorsComparison = null;

			// VALEUR DU SEO
			this.topKeywordsSEOValueByKeyword = [];
			this.topKeywordsSEOValueOptions = null;
			this.topKeywordsSEOValue = [];
			this.keywordsSEOValueOptions = null;
			(this.keywordsSEOValue = []),
				// PROPS DATA
				(this.impComparisonChartOptions = null);
			this.keywordData = []; // STORE DATA FROM GOOGLE APIS
			this.topKeywords = [];
			this.topKeywordData = {};
			this.topKeywordMergedData = [];

			// API data
			this.apiLastUpdate = {
				gsc: null,
				ads: null,
				georanker: null,
			};

			//Ads
			this.topKeywordHistData = [];

			//Top Keywords comparison by keyword
			this.topKeywordsSERPComparison = {};

			//Competitors
			this.competitors = [];

			//Brands
			this.brands = [];
			this.brandDataTotal = {
				clicks: 0,
				impressions: 0,
				ctr: 0.0,
				position: 0,
			};
		},

		closeLoading() {
			this.loading = false;
			window.dispatchEvent(new Event("resize"));
		},

		computeDifferenceForPotential(value, compareTo, range = 1) {
			let differenceToCompute = (value / compareTo - 1) * range;
			// //console.log(value, compareTo, range, differenceToCompute)
			return differenceToCompute > 0 ? differenceToCompute : 0;
		},

		containsWord(str, word) {
			return str.match(new RegExp(word)) != null;
		},

		isMainActiveTab(tabId) {
			if (this.$refs.mainTabs && this.$refs.mainTabs.childActive == tabId) {
				if (tabId == "2") {
					//console.log("isMainActiveTab 2");
					// OPTIONNAL
					if (
						this.stackedBarChartOptionsTopKeywordsCompetitorsComparison == null
					) {
						this.setStackedBarChartOptionsTopKeywordsCompetitorsComparison();
					}
					return true;
				} else {
					return true;
				}
			}
			return false;
		},

		makeDateXaxis() {
			let xaxis = [];
			let fromDate = new Date(this.fromDate);
			let toDate = new Date(this.toDate);
			let startMonth = fromDate.getMonth();
			let startYear = fromDate.getFullYear();
			while (startYear <= toDate.getFullYear()) {
				if (startYear < toDate.getFullYear()) {
					while (startMonth <= 11) {
						if (startMonth + 1 < 10) {
							xaxis.push(`${startYear}-0${startMonth + 1}`);
						} else {
							xaxis.push(`${startYear}-${startMonth + 1}`);
						}
						startMonth = startMonth + 1;
					}
				} else {
					while (startMonth <= toDate.getMonth()) {
						if (startMonth + 1 < 10) {
							xaxis.push(`${startYear}-0${startMonth + 1}`);
						} else {
							xaxis.push(`${startYear}-${startMonth + 1}`);
						}
						startMonth = startMonth + 1;
					}
				}
				startMonth = 0;
				startYear = startYear + 1;
			}
			return xaxis;
		},

		openLoading() {
			this.loading = true;
			this.$vs.loading({
				container: "#popupContainer",
			});
		},

		selectEvolutionKeyword(keyword) {
			this.selectedEvolutionKeyword = keyword;
			this.evolutionPopupActive = true;
		},

		testGscAccess(gsc_url) {
			return new Promise((resolve) => {
				this.$http
					.post(this.apiUrl + "webmaster/testaccess", {
						url: gsc_url,
					})
					.then((haveAccess) => {
						this.haveGscAccess = haveAccess.data;
						resolve(haveAccess);
					})
					.catch(() => {
						resolve(false);
					});
			});
		},

		// 0002 - Get

		getRevenue(fromDate, toDate) {
			return new Promise((resolve) => {
				// //console.log("getRevenue analytics_id",this.selectedSociety.analytics_id)
				if (this.selectedSociety.analytics_id == null)
					resolve([
						{
							totalValue: 0,
						},
						0,
					]);
				this.$http
					.post(this.apiUrl + "analytic/site/transactionsdata", {
						viewId: this.selectedSociety.analytics_id,
						fromDate: fromDate,
						toDate: toDate,
					})
					.then((res) => {
						this.haveAnalyticsAccess = true;
						resolve(res.data);
					})
					.catch((err) => {
						//console.log(err);
						this.haveAnalyticsAccess = false;
						resolve([
							{
								totalValue: 0,
							},
							0,
						]);
					});
			});
		},
		getRevenueByProduct(fromDate, toDate) {
			return new Promise((resolve) => {
				// //console.log("getRevenue analytics_id",this.selectedSociety.analytics_id)
				if (this.selectedSociety.analytics_id == null)
					resolve([
						{
							totalValue: 0,
						},
						0,
					]);
				this.$http
					.post(this.apiUrl + "analytic/site/productsdata", {
						viewId: this.selectedSociety.analytics_id,
						fromDate: fromDate,
						toDate: toDate,
					})
					.then((res) => {
						this.haveAnalyticsAccess = true;
						resolve(res.data);
					})
					.catch((err) => {
						//console.log(err);
						this.haveAnalyticsAccess = false;
						resolve([
							{
								totalValue: 0,
							},
							0,
						]);
					});
			});
		},

		getConversion(fromDate, toDate) {
			return new Promise((resolve) => {
				// //console.log("getConversion analytics_id",this.selectedSociety.analytics_id)
				if (this.selectedSociety.analytics_id == null) resolve(0);
				this.$http
					.post(this.apiUrl + "analytic/site/goalsdata", {
						viewId: this.selectedSociety.analytics_id,
						fromDate: fromDate,
						toDate: toDate,
					})
					.then((res) => {
						/*
						 * let organicConversion = 0
						 * let analyticsData = res.data.data.reports[0].data.rows
						 * for(let i = 0; i < analyticsData.length; i++){
						 *   let dimensionsDetails = analyticsData[i].dimensions[0].split('/').map(row => row.trim())
						 *   if(dimensionsDetails[1] == "organic"){
						 *     organicConversion += parseFloat(analyticsData[i].metrics[0].values[9])
						 *   }
						 * }
						 */
						this.haveAnalyticsAccess = true;
						resolve(res.data);
					})
					.catch(() => {
						this.haveAnalyticsAccess = false;
						resolve(0);
					});
			});
		},

		getRevenuesForSociety() {
			return new Promise((resolve) => {
				let to_actual_month = this.statDateFilter.toDate;
				let from_actual_month =
					this.statDateFilter.toDate.substring(0, 8) + "01";

				let from_actual_month_object = new Date(from_actual_month);
				from_actual_month_object.setDate(0);

				let to_last_month = from_actual_month_object
					.toISOString()
					.substring(0, 10);
				let from_last_month = to_last_month.substring(0, 8) + "01";

				let queries = [];
				queries.push(
					this.getRevenueByProduct(from_actual_month, to_actual_month)
				);
				queries.push(this.getRevenueByProduct(from_last_month, to_last_month));
				queries.push(this.getRevenue(from_actual_month, to_actual_month));
				queries.push(this.getRevenue(from_last_month, to_last_month));

				Promise.all(queries).then((results) => {
					// //console.log("getRevenuesForSociety", results)
					this.actualMonthRevenue = Math.round(results[2][0].totalValue);
					this.actualMonthSoldItems = [...results[0]];
					this.actualMonthSoldItems.shift();
					this.lastMonthRevenue = Math.round(results[3][0].totalValue);
					this.lastMonthSoldItems = [...results[1]];
					this.lastMonthSoldItems.shift();

					this.revenueEvolution.statistics =
						this.actualMonthRevenue > 0
							? this.formatThousandNumb(this.actualMonthRevenue)
							: 0;
					this.revenueEvolution.value = Math.round(
						this.actualMonthRevenue - this.lastMonthRevenue
					);
					if (this.revenueEvolution.value < 0) {
						this.revenueEvolution.icon = "icon-arrow-down-right";
						this.revenueEvolution.color = "danger";
					} else if (this.revenueEvolution.value > 0) {
						this.revenueEvolution.icon = "icon-arrow-up-right";
						this.revenueEvolution.color = "success";
					} else {
						this.revenueEvolution.itext = "=";
						this.revenueEvolution.color = "grey";
					}
					this.revenueEvolution.value = this.formatThousandNumb(
						this.revenueEvolution.value
					);
					resolve(true);
				});
			});
		},

		getConversionsForSociety() {
			return new Promise((resolve) => {
				let to_actual_month = this.statDateFilter.toDate;
				let from_actual_month =
					this.statDateFilter.toDate.substring(0, 8) + "01";

				let from_actual_month_object = new Date(from_actual_month);
				from_actual_month_object.setDate(0);

				let to_last_month = from_actual_month_object
					.toISOString()
					.substring(0, 10);
				let from_last_month = to_last_month.substring(0, 8) + "01";

				let queries = [];
				queries.push(this.getConversion(from_actual_month, to_actual_month));
				queries.push(this.getConversion(from_last_month, to_last_month));

				Promise.all(queries).then((results) => {
					// //console.log("getConversionsForSociety",results)
					this.actualMonthConversion = results[0];
					this.lastMonthConversion = results[1];

					let actualMonthConversionTotal = 0;
					for (let i = 0; i < this.actualMonthConversion.length; i++) {
						actualMonthConversionTotal += this.actualMonthConversion[i].value;
					}
					this.actualMonthConversionTotal = actualMonthConversionTotal;

					let lastMonthConversionTotal = 0;
					for (let i = 0; i < this.lastMonthConversion.length; i++) {
						lastMonthConversionTotal += this.lastMonthConversion[i].value;
					}
					this.lastMonthConversionTotal = lastMonthConversionTotal;

					this.conversionEvolution.statistics =
						actualMonthConversionTotal > 0
							? this.formatThousandNumb(Math.round(actualMonthConversionTotal))
							: 0;
					this.conversionEvolution.value = Math.round(
						actualMonthConversionTotal - lastMonthConversionTotal
					);
					if (this.conversionEvolution.value < 0) {
						this.conversionEvolution.icon = "icon-arrow-down-right";
						this.conversionEvolution.color = "danger";
					} else if (this.conversionEvolution.value > 0) {
						this.conversionEvolution.icon = "icon-arrow-up-right";
						this.conversionEvolution.color = "success";
					} else {
						this.conversionEvolution.itext = "=";
						this.conversionEvolution.color = "grey";
					}
					this.conversionEvolution.value = this.formatThousandNumb(
						this.conversionEvolution.value
					);
					resolve(true);
				});
			});
		},

		getConversionsOrRevenues() {
			return new Promise((resolve) => {
				let queries = [];
				queries.push(this.getConversionsForSociety());
				if (this.selectedSociety.is_ecommerce == 1) {
					queries.push(this.getRevenuesForSociety());
				}
				Promise.all(queries).then(() => resolve(true));
			});
		},

		getAverageCTRByPosition(allData) {
			return new Promise((resolve) => {
				let ctrAverages = {
					ranges: [
						[1, 1],
						[2, 2],
						[3, 3],
						[4, 4],
						[5, 5],
						[6, 6],
						[7, 7],
						[8, 8],
						[9, 9],
						[10, 10],
						[11, 20],
						[21, 50],
						[51, 100],
					],
					averages: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
					ocurrencies: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
				};
				//console.log("allData", allData);
				for (let year in allData) {
					// //console.log("allData",allData[year].data)
					const data = allData[year];
					for (let month = 0; month < data.length; month++) {
						if (data[month]) {
							for (let row = 0; row < data[month].length; row++) {
								if (data[month][row].impressions > 10) {
									const foundIndex = ctrAverages.ranges.findIndex(
										(range) =>
											range[0] <= data[month][row].position &&
											range[1] >= data[month][row].position
									);
									if (foundIndex >= 0) {
										ctrAverages.averages[foundIndex] +=
											data[month][row].clicks / data[month][row].impressions;
										ctrAverages.ocurrencies[foundIndex] += 1;
									}
								}
							}
						}
					}
				}
				let isMissingAverage = false;
				for (
					let averageIndex = 0;
					averageIndex < ctrAverages.averages.length;
					averageIndex++
				) {
					if (ctrAverages.ocurrencies[averageIndex] < 10) {
						/*
						 * const estimatedCtr = this.getEstimatedCTRfromPosition(ctrAverages.ranges[averageIndex][0])
						 * const ctrDiff  = (ctrAverages.averages[averageIndex] - estimatedCtr) / ctrAverages.averages[averageIndex]
						 */
						ctrAverages.averages[averageIndex] = -1;
						isMissingAverage = true;
					} else {
						ctrAverages.averages[averageIndex] =
							ctrAverages.averages[averageIndex] /
							ctrAverages.ocurrencies[averageIndex];
					}
				}
				if (isMissingAverage) {
					let missingAverageIndexes = [];
					let averageDiff = 0;
					let averageDiffCount = 0;
					for (
						let averageIndex = 0;
						averageIndex < ctrAverages.averages.length;
						averageIndex++
					) {
						if (ctrAverages.averages[averageIndex] < 0) {
							missingAverageIndexes.push(averageIndex);
						} else {
							// CTRT - CTRR / CTRT
							const ctrt = this.getEstimatedCTRfromPosition(
								ctrAverages.ranges[averageIndex][0]
							);
							averageDiff +=
								ctrAverages.averages[averageIndex] > 0
									? (ctrt - ctrAverages.averages[averageIndex]) / ctrt
									: 0; // Que faire si ctrAverage = 0 ?
							// //console.log("ctrAverages.ranges[averageIndex][0], ctrt, (ctrt - ctrAverages.averages[averageIndex]), averageDiff", ctrAverages.ranges[averageIndex][0], ctrt, (ctrt - ctrAverages.averages[averageIndex]), averageDiff)
							averageDiffCount += 1;
						}
					}
					averageDiff =
						averageDiffCount > 0 ? averageDiff / averageDiffCount : 0;

					for (let i = 0; i < missingAverageIndexes.length; i++) {
						const ctrt = this.getEstimatedCTRfromPosition(
							ctrAverages.ranges[missingAverageIndexes[i]][0]
						);
						ctrAverages.averages[missingAverageIndexes[i]] =
							ctrt * (1 - averageDiff);
					}
				}
				resolve(ctrAverages);
			});
		},

		getAverageCTRByPositionForYear(year, data) {
			return new Promise((resolve) => {
				let ctrAverages = {
					ranges: [
						[1, 1],
						[2, 2],
						[3, 3],
						[4, 4],
						[5, 5],
						[6, 6],
						[7, 7],
						[8, 8],
						[9, 9],
						[10, 10],
						[11, 20],
						[21, 50],
						[51, 100],
					],
					averages: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
					ocurrencies: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
					year: year,
				};

				for (let month = 0; month < data.length; month++) {
					for (let row = 0; row < data[month].length; row++) {
						if (data[month][row].impressions > 10) {
							const foundIndex = ctrAverages.ranges.findIndex(
								(range) =>
									range[0] <= data[month][row].position &&
									range[1] >= data[month][row].position
							);
							if (foundIndex >= 0) {
								ctrAverages.averages[foundIndex] +=
									data[month][row].clicks / data[month][row].impressions;
								ctrAverages.ocurrencies[foundIndex] += 1;
							}
						}
					}
				}

				for (
					let averageIndex = 0;
					averageIndex < ctrAverages.averages.length;
					averageIndex++
				) {
					ctrAverages.averages[averageIndex] =
						ctrAverages.ocurrencies[averageIndex] > 0
							? ctrAverages.averages[averageIndex] /
							  ctrAverages.ocurrencies[averageIndex]
							: -1;
				}
				resolve(ctrAverages);
			});
		},

		computeEvolution(keywordListingFull) {
			for (let i = 0; i < keywordListingFull.data.length; i++) {
				this.getChartPopupKeywordsData(
					keywordListingFull.data[i].keyword.replace("'", "%5C%27")
				).then((data) => {
					if (data.length == 1) {
						keywordListingFull.data[i].diff = "";
					} else if (data.length > 1) {
						let diff =
							data[data.length - 2]["position"] -
							data[data.length - 1]["position"];
						if (diff < 0) {
							// keywordListingFull.data[i].diff = "↓" + Math.abs(diff)
							keywordListingFull.data[i].diff = diff;
						} else if (diff == 0) {
							// keywordListingFull.data[i].diff = "→"
							keywordListingFull.data[i].diff = diff;
						} else if (diff > 0) {
							// keywordListingFull.data[i].diff = "↑" + Math.abs(diff)
							keywordListingFull.data[i].diff = diff;
						}
					}
				});
			}
		},

		getChartPopupKeywordsData(keyword) {
			return new Promise((resolve, reject) => {
				this.$http
					.get(
						this.apiUrl +
							"webmaster/gscKwData/" +
							this.selectedSociety.id +
							"/" +
							keyword +
							"/" +
							this.fromDate +
							"/" +
							this.toDate
					)
					.then((result) => {
						resolve(result.data);
					})
					.catch((err) => {
						//console.log(err);
						reject([]);
					});
			});
		},

		/**
		 * Query the API to get informations about each keyword during a period
		 * This data is used for the main table
		 * @param {Society} society - Current society
		 * @param {Date} fromDate - Starting date of the wanted data
		 * @param {Date} toDate - Ending date of the wanted data
		 */
		getKeywordData(society, fromDate, toDate) {
			return new Promise((resolve, reject) => {
				this.testGscAccess(society.gsc_url);
				console.time("getKeywordData");
				let strFromDate = fromDate
					? fromDate.substring(0, 10)
					: this.today.substring(0, 10);
				let strToDate = toDate
					? toDate.substring(0, 10)
					: this.today.substring(0, 10);
				console.time("webmaster-gscdata");
				this.$http
					.get(
						this.apiUrl +
							`webmaster/gscData/${society.id}/${strFromDate}/${strToDate}`
					)
					.then(async (result) => {
						console.timeEnd("webmaster-gscdata");
						let keywordData = result.data;
						console.time("for-gscdata-result");
						//console.log("result.data", result.data);
						/*
						 * for(let yearRow of result.data){
						 *   keywordData[yearRow.year] = JSON.parse(yearRow.data)
						 *   // this.getAverageCTRByPositionForYear(yearRow.year, keywordData[yearRow.year]).then(ctrAverages => this.allCtrAverages.push(ctrAverages))
						 * }
						 */
						console.timeEnd("for-gscdata-result");
						console.time("getaveragectrbyposition");
						await this.getAverageCTRByPosition(result.data).then(
							(ctrAverages) => (this.allCtrAverages = ctrAverages)
						);
						console.timeEnd("getaveragectrbyposition");
						this.keywordData = keywordData;

						this.keywordListingFull = {
							data: [],
							date: "",
						};
						let today = new Date(Date.now());
						let year = today.getFullYear();
						let month = today.getMonth() - 1;
						this.keywordListingFull.date = `${month + 1}/${year}`;

						console.time("gscDataListing");
						let resultData = await this.$http.get(
							this.apiUrl +
								`webmaster/gscDataListing/${society.id}/${strFromDate}/${strToDate}`
						);
						console.timeEnd("gscDataListing");
						let monthData = resultData.data;
						console.time("for-monthdata");
						/*
						 * for(let row of monthData){
						 *   row.potential = Math.round(this.getKeywordPotential(Math.round(row.last_position), row.clicks, row.impressions) * this.getPotentialModifierForKeyword(row.keyword))
						 * }
						 */
						console.timeEnd("for-monthdata");

						console.time("sort-monthdata");
						monthData.sort((a, b) => {
							// Use toUpperCase() to ignore character casing
							const keywordA = a.impressions;
							const keywordB = b.impressions;

							let comparison = 0;
							if (keywordA < keywordB) {
								comparison = 1;
							} else if (keywordA > keywordB) {
								comparison = -1;
							}
							return comparison;
						});
						console.timeEnd("sort-monthdata");
						this.keywordListingFull.data = monthData;

						// this.computeEvolution(this.keywordListingFull)

						// }
						console.timeEnd("getKeywordData");
						resolve(result);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},

		getTopKeywordData(completeRefresh = false) {
			return new Promise((resolve) => {
				let xaxis = this.makeDateXaxis();
				// IF USER HAS NO TOP KEYWORDS THEN EMPTY THE TOPKEYWORD DATA
				if (
					this.topKeywords &&
					this.topKeywords.length > 0 &&
					this.keywordData.length !== {}
				) {
					let topKeywordData = {};
					for (let topKeyword of this.topKeywords) {
						let lcTopKeyword = topKeyword.toLowerCase();
						topKeywordData[lcTopKeyword.toLowerCase()] = {};
						for (let yearKey in this.keywordData) {
							if (this.keywordData && this.keywordData[yearKey]) {
								let filteredMonthData = this.keywordData[yearKey].map(
									(monthData) => {
										let keywordMonthData = monthData
											? monthData.filter((row) => row.keyword == lcTopKeyword)
											: [];
										return keywordMonthData.length > 0
											? keywordMonthData[0]
											: null;
									}
								);
								topKeywordData[lcTopKeyword][yearKey] = filteredMonthData;
							} else {
								topKeywordData[lcTopKeyword][yearKey] = [];
							}
						}
					}
					let today = new Date(Date.now());
					let year = today.getFullYear();
					let month = today.getMonth() - 1;
					this.topKeywordData = topKeywordData;
					this.topKeywordListingFull = {
						data: [],
						date: "",
					};
					this.topKeywordListingFull.date = `${month + 1}/${year}`;
					if (this.keywordData && Object.entries(this.keywordData).length > 0) {
						let monthData = [];
						for (let tk of this.topKeywords) {
							let foundTkVolume = -1;
							if (
								this.topKeywordsSERPComparison.keywords_info &&
								this.topKeywordsSERPComparison.keywords_info[tk]
							)
								foundTkVolume =
									this.topKeywordsSERPComparison.keywords_info[tk].volume;
							let foundTk = this.keywordListingFull.data.findIndex(
								(row) => row.keyword == tk
							);
							if (foundTk >= 0) {
								monthData.push({
									keyword: tk,
									volume: foundTkVolume,
									ctr: this.keywordListingFull.data[foundTk].ctr,
									position: this.keywordListingFull.data[foundTk].position,
									clicks: this.keywordListingFull.data[foundTk].clicks,
									impressions:
										this.keywordListingFull.data[foundTk].impressions,
									counter: this.keywordListingFull.data[foundTk].counter,
									diff: this.keywordListingFull.data[foundTk].diff,
									last_position:
										this.keywordListingFull.data[foundTk].last_position,
									last_position_year:
										this.keywordListingFull.data[foundTk].last_position_year,
									last_position_month:
										this.keywordListingFull.data[foundTk].last_position_month,
									potential: this.keywordListingFull.data[foundTk].potential,
									data: [...this.keywordListingFull.data[foundTk].data],
								});
							} else {
								monthData.push({
									keyword: tk,
									volume: foundTkVolume,
									ctr: 0,
									position: 0,
									clicks: 0,
									impressions: 0,
									counter: 0,
									diff: 0,
									last_position: 0,
									last_position_year: 0,
									last_position_month: 0,
									potential: 0,
									data: [],
								});
							}
						}

						monthData.sort((a, b) => {
							// Use toUpperCase() to ignore character casing
							const keywordA = a.impressions;
							const keywordB = b.impressions;

							let comparison = 0;
							if (keywordA < keywordB) {
								comparison = 1;
							} else if (keywordA > keywordB) {
								comparison = -1;
							}
							return comparison;
						});
						this.topKeywordListingFull.data = monthData;
					}

					this.topKeywordListingFull.data.sort((a, b) => {
						// Use toUpperCase() to ignore character casing
						const keywordA = a.clicks;
						const keywordB = b.clicks;

						let comparison = 0;
						if (keywordA < keywordB) {
							comparison = 1;
						} else if (keywordA > keywordB) {
							comparison = -1;
						} else if (keywordA == keywordB && a.impressions < b.impressions) {
							comparison = 1;
						} else if (keywordA == keywordB && a.impressions > b.impressions) {
							comparison = -1;
						}
						return comparison;
					});
					// this.computeEvolution(this.topKeywordListingFull);
					console.time("georanker/getKD2");
					this.$http
						.post(this.apiUrl + "georanker/getKD/" + this.selectedSociety.id)
						.then((res) => {
							for (let i = 0; i < this.topKeywordListingFull.data.length; i++) {
								this.topKeywordListingFull.data[i]["kd"] =
									res.data[this.topKeywordListingFull.data[i].keyword];
							}
							let queries = [];
							queries.push(this.getDataPerDateTopKeywords());
							if (completeRefresh) {
								queries.push(this.getDataPerDateTopKeywords());
								queries.push(this.setTopKeywordsHistDataOptions());
							}
							Promise.all(queries).then(() => {
								resolve(true);
							});
							console.timeEnd("georanker/getKD2");
						})
						.catch((errr) => {
							//console.log("georanker/getKD: ", errr);
						});
				} else {
					this.topKeywordData = null;
					resolve(false);
				}
			});
		},

		getBrandData(completeRefresh = false) {
			return new Promise((resolve, reject) => {
				if (this.brands == null) {
					this.brandData = null;
				} else {
					let brandData = {};
					let xaxis = this.makeDateXaxis();
					let series = [
						{
							data: Array(xaxis.length).fill(0),
							name: "Clics",
						},
						{
							data: Array(xaxis.length).fill(0),
							name: "Impressions",
						},
					];
					let totalClicks = 0;
					let totalImpressions = 0;
					let averagePosition = 0;
					let totalResult = 0;
					let fromYear = this.fromDate.substring(0, 4);
					let fromMonth = this.fromDate.substring(5, 7);
					let toYear = this.toDate.substring(0, 4);
					let toMonth = this.toDate.substring(5, 7);

					let keywordRowCounterBool = true;
					let keywordRowCounter = 0;
					let globalTotalPos = 0;
					let globalTotalClicks = 0;
					let globalTotalImpressions = 0;
					for (
						let brandIndex = 0;
						brandIndex < this.brands.length;
						brandIndex++
					) {
						brandData[this.brands[brandIndex]] = {};
						for (let yearKey in this.keywordData) {
							if (
								parseInt(yearKey) <= toYear &&
								parseInt(yearKey) >= fromYear
							) {
								let filteredMonthData = [];
								for (
									let monthData = 0;
									monthData < this.keywordData[yearKey].length;
									monthData++
								) {
									let keywordMonthData = [];
									if (
										(yearKey == fromYear &&
											fromYear != toYear &&
											parseInt(monthData) + 1 >= parseInt(fromMonth)) ||
										(yearKey == fromYear &&
											fromYear == toYear &&
											parseInt(monthData) + 1 >= parseInt(fromMonth) &&
											parseInt(monthData) + 1 <= parseInt(toMonth)) ||
										(yearKey == toYear &&
											fromYear != toYear &&
											parseInt(monthData) + 1 <= parseInt(toMonth)) ||
										(yearKey > fromYear && yearKey < toYear)
									) {
										for (
											let rowIndex = 0;
											rowIndex < this.keywordData[yearKey][monthData].length;
											rowIndex++
										) {
											if (keywordRowCounterBool) {
												globalTotalPos += isNaN(
													this.keywordData[yearKey][monthData][rowIndex]
														.position
												)
													? 100
													: this.keywordData[yearKey][monthData][rowIndex]
															.position;
												globalTotalClicks +=
													this.keywordData[yearKey][monthData][rowIndex].clicks;
												globalTotalImpressions +=
													this.keywordData[yearKey][monthData][rowIndex]
														.impressions;
												keywordRowCounter += 1;
											}
											let matched = this.containsWord(
												this.keywordData[yearKey][monthData][
													rowIndex
												].keyword.toLowerCase(),
												this.brands[brandIndex].toLowerCase()
											);
											if (matched) {
												let foundIndex = xaxis.findIndex(
													(row) =>
														row.substring(0, 4) == yearKey &&
														parseInt(monthData) + 1 == row.substring(5, 7)
												);
												if (foundIndex >= 0) {
													series[0].data[foundIndex] +=
														this.keywordData[yearKey][monthData][
															rowIndex
														].clicks;
													series[1].data[foundIndex] +=
														this.keywordData[yearKey][monthData][
															rowIndex
														].impressions;
												}
												totalResult = totalResult + 1;
												totalClicks =
													totalClicks +
													this.keywordData[yearKey][monthData][rowIndex].clicks;
												totalImpressions =
													totalImpressions +
													this.keywordData[yearKey][monthData][rowIndex]
														.impressions;
												averagePosition = isNaN(
													this.keywordData[yearKey][monthData][rowIndex]
														.position
												)
													? 100
													: averagePosition +
													  this.keywordData[yearKey][monthData][rowIndex]
															.position;
												keywordMonthData.push(
													this.keywordData[yearKey][monthData][rowIndex]
												);
											}
										}
									}

									if (keywordMonthData && keywordMonthData.length > 0) {
										filteredMonthData.push(keywordMonthData);
									} else {
										filteredMonthData.push(null);
									}
								}
								let max = 0;
								for (let i = 0; i < xaxis.length; i++) {
									max =
										max < series[0].data[i] + series[1].data[i]
											? series[0].data[i] + series[1].data[i]
											: max;
								}
								this.stackedColumnChartOptionBrandTrafficSeriesAndXaxis = {
									data: series,
									max: max,
									xaxis: xaxis,
								};
								brandData[this.brands[brandIndex]][yearKey] = filteredMonthData;
							}
						}
						keywordRowCounterBool = false;
					}

					this.brandData = brandData;
					let brandDataTotal = this.displayBrandListPopup();

					/*
					 * GENERIQUE POSITION CTR RESULT_NUM (GLOBAL-BRAND)
					 * RESULT KEYWORD LENGTH
					 * CLICK TOTAL + IMPRESSION
					 */
					this.genericPosition = Math.round(
						(globalTotalPos - brandDataTotal.position) /
							(keywordRowCounter - brandDataTotal.counter)
					);

					this.genericCTR =
						((globalTotalClicks - brandDataTotal.clicks) /
							(globalTotalImpressions - totalImpressions)) *
						100;

					this.brandDataTotal = {
						clicks: brandDataTotal.clicks,
						impressions: brandDataTotal.impressions,
						ctr: brandDataTotal.averageCTR,
						position: brandDataTotal.averagePosition,
					};
				}
				let queries = [];
				queries.push(this.setStackedBarChartOptionsBrandTraffic());
				if (completeRefresh) {
					queries.push(this.getImpComparisonChartOptions(this.brandDataTotal));
				}
				Promise.all(queries)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						//console.log(error);
						reject(error);
					});
			});
		},

		getApiLastUpdate() {
			return new Promise((resolve) => {
				this.$http
					.get(
						this.apiUrl + "society/getApiLastUpdate/" + this.selectedSociety.id
					)
					.then((result) => {
						let re = new RegExp("([T|Z])", "g");
						this.apiLastUpdate.ads = result.data[0].ads
							? new Date(result.data[0].ads.replace(re, " "))
							: "";
						this.apiLastUpdate.gsc = result.data[0].gsc
							? new Date(result.data[0].gsc.replace(re, " "))
							: "";
						this.apiLastUpdate.georanker = result.data[0].georanker
							? new Date(result.data[0].georanker.replace(re, " "))
							: "";
						let last_update_object = this.apiLastUpdate.ads;
						last_update_object =
							last_update_object < this.apiLastUpdate.gsc
								? this.apiLastUpdate.gsc
								: last_update_object;
						last_update_object =
							last_update_object < this.apiLastUpdate.georanker
								? this.apiLastUpdate.georanker
								: last_update_object;
						this.last_update = last_update_object
							? last_update_object
									.toISOString()
									.substring(0, 10)
									.split("-")
									.reverse()
									.join("/")
							: "";
						resolve(this.last_update);
					});
			});
		},

		/**
		 * Query the API to get the rank of the most visited page of a gsc
		 * This data is used in the "clics par page" table
		 * @param {Date} fromDate - Starting date of the wanted data
		 * @param {Date} toDate - Ending date of the wanted data
		 */
		getPageRankData() {
			return new Promise((resolve, reject) => {
				console.time("getPageRankData");
				let fromDate = this.fromDate;
				let toDate = this.toDate;

				if (toDate == null) {
					toDate = this.today;
				}
				if (fromDate == null) {
					fromDate = toDate;
				}

				this.pageRankData = null;
				let strFromDateYear = fromDate
					? fromDate.substring(0, 4)
					: this.today.substring(0, 4);
				let strToDateYear = toDate
					? toDate.substring(0, 4)
					: this.today.substring(0, 4);
				let strFromDateMonth = fromDate
					? fromDate.substring(5, 7)
					: this.today.substring(5, 7);
				let strToDateMonth = toDate
					? toDate.substring(5, 7)
					: this.today.substring(5, 7);

				this.$http
					.get(
						this.apiUrl +
							`webmaster/gscPageData/${this.selectedSociety.id}/${strFromDateYear}/${strToDateYear}`
					)
					.then((result) => {
						let pagesData = {};

						for (let yearRow of result.data) {
							pagesData[yearRow.year] = JSON.parse(yearRow.data);
						}

						let pagesRankData = [];
						for (let yearRow in pagesData) {
							if (yearRow.length > 0) {
								if (
									parseInt(strFromDateYear) <= parseInt(yearRow) &&
									parseInt(strToDateYear) >= parseInt(yearRow)
								) {
									for (let monthData in pagesData[yearRow]) {
										if (
											(parseInt(strFromDateYear) == yearRow &&
												parseInt(strFromDateMonth) <=
													parseInt(monthData) + 1) ||
											(parseInt(strToDateYear) == yearRow &&
												parseInt(strToDateMonth) >= parseInt(monthData) + 1)
										) {
											// == <= >= year
											if (
												pagesData[yearRow][monthData] &&
												pagesData[yearRow][monthData].length > 0
											) {
												for (let page of pagesData[yearRow][monthData]) {
													let pageIndex = pagesRankData.findIndex(
														(pageRD) => pageRD.keys[0] == page.keyword
													);
													if (pageIndex >= 0) {
														pagesRankData[pageIndex].clicks =
															pagesRankData[pageIndex].clicks + page.clicks;
														pagesRankData[pageIndex].impressions =
															pagesRankData[pageIndex].impressions +
															page.impressions;
													} else {
														pagesRankData.push({
															keys: [page.keyword],
															clicks: page.clicks,
															impressions: page.impressions,
														});
													}
												}
											}
										} else if (
											parseInt(strFromDateYear) < yearRow &&
											parseInt(strToDateYear) > yearRow
										) {
											if (
												pagesData[yearRow][monthData] &&
												pagesData[yearRow][monthData].length > 0
											) {
												for (let page of pagesData[yearRow][monthData]) {
													let pageIndex = pagesRankData.findIndex(
														(pageRD) => pageRD.keys[0] == page.keyword
													);
													if (pageIndex >= 0) {
														pagesRankData[pageIndex].clicks =
															pagesRankData[pageIndex].clicks + page.clicks;
														pagesRankData[pageIndex].impressions =
															pagesRankData[pageIndex].impressions +
															page.impressions;
													} else {
														pagesRankData.push({
															keys: [page.keyword],
															clicks: page.clicks,
															impressions: page.impressions,
														});
													}
												}
											}
										}
									}
								}
							}
						}

						pagesRankData.sort((a, b) => {
							// Use toUpperCase() to ignore character casing
							const keywordA = a.clicks;
							const keywordB = b.clicks;

							let comparison = 0;
							if (keywordA < keywordB) {
								comparison = 1;
							} else if (keywordA > keywordB) {
								comparison = -1;
							}
							return comparison;
						});

						this.pageRankData = pagesRankData;

						console.timeEnd("getPageRankData");
						resolve(pagesRankData);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},

		/**
		 * Query the API to get data about a gsc for defined period (1 year here)
		 * @param {String} gscUrl - URL of the gsc of the client/society
		 */
		getDataPerDateTopKeywords() {
			return new Promise((resolve) => {
				console.time("getDataPerDate");

				this.globalDataPerDate = null;
				// Array that will store our data
				let chartParamTopKeywords = {
					keys: { data: [], name: "key" },
					imp: { data: [], name: "Impressions" },
					clicks: { data: [], name: "Clics" },
					ctr: { data: [], name: "CTR" },
					pos: { data: [], name: "Position Moyenne" },
				};

				let xaxis = [];
				let fromDate = new Date(this.fromDate);
				let toDate = new Date(this.toDate);
				let startMonth = fromDate.getMonth();
				let startYear = fromDate.getFullYear();
				while (startYear <= toDate.getFullYear()) {
					if (startYear < toDate.getFullYear()) {
						while (startMonth <= 11) {
							if (startMonth + 1 < 10) {
								xaxis.push(`${startYear}-0${startMonth + 1}`);
							} else {
								xaxis.push(`${startYear}-${startMonth + 1}`);
							}
							startMonth = startMonth + 1;
						}
					} else {
						while (startMonth <= toDate.getMonth()) {
							if (startMonth + 1 < 10) {
								xaxis.push(`${startYear}-0${startMonth + 1}`);
							} else {
								xaxis.push(`${startYear}-${startMonth + 1}`);
							}
							startMonth = startMonth + 1;
						}
					}

					startMonth = 0;
					startYear = startYear + 1;
				}

				// TOP KEYWORDS
				let globalSiteData = {
					clicks: 0,
					impressions: 0,
					ctr: 0,
					position: 0,
				};

				for (let date of xaxis) {
					let clicks = 0;
					let impressions = 0;
					let position = 0;
					let ctr = 0;
					let year = date.substring(0, 4);
					let month = parseInt(date.substring(5, 7)) - 1;

					for (let keyword in this.topKeywordData) {
						clicks =
							this.topKeywordData &&
							this.topKeywordData[keyword][year] &&
							this.topKeywordData[keyword][year][month] != null
								? clicks + this.topKeywordData[keyword][year][month].clicks
								: clicks;
						impressions =
							this.topKeywordData &&
							this.topKeywordData[keyword][year] &&
							this.topKeywordData[keyword][year][month] != null
								? impressions +
								  this.topKeywordData[keyword][year][month].impressions
								: impressions;
						position =
							this.topKeywordData &&
							this.topKeywordData[keyword][year] &&
							this.topKeywordData[keyword][year][month] != null
								? position + this.topKeywordData[keyword][year][month].position
								: position;
					}

					globalSiteData.clicks = globalSiteData.clicks + clicks;
					globalSiteData.impressions = globalSiteData.impressions + impressions;

					position =
						Object.keys(this.topKeywordData).length > 0
							? position / Object.keys(this.topKeywordData).length
							: 100; // ATTENTION A RECALCULER
					position = position === 0 ? 100 : position;

					globalSiteData.position = globalSiteData.position + position;

					position = position == 0 ? 100 : position;
					ctr = (clicks / impressions) * 100;
					ctr = isNaN(ctr) ? 0 : ctr;

					chartParamTopKeywords.clicks.data.push(Math.trunc(clicks));
					chartParamTopKeywords.imp.data.push(Math.trunc(impressions));
					chartParamTopKeywords.pos.data.push(Math.trunc(position));
					chartParamTopKeywords.ctr.data.push(parseFloat(ctr.toFixed(2)));
				}

				globalSiteData.position = globalSiteData.position / xaxis.length;
				globalSiteData.ctr = parseFloat(
					((globalSiteData.clicks / globalSiteData.impressions) * 100).toFixed(
						2
					)
				);

				this.globalSiteData = globalSiteData;

				let datesGlobalDataAreaChartTopKeywords = xaxis
					? xaxis.map((xdate) => xdate.split("-").reverse().join("/"))
					: [];
				let today = new Date(Date.now());
				if (
					datesGlobalDataAreaChartTopKeywords.length > 0 &&
					datesGlobalDataAreaChartTopKeywords[
						datesGlobalDataAreaChartTopKeywords.length - 1
					].substring(3, 7) == today.getFullYear() &&
					parseInt(
						datesGlobalDataAreaChartTopKeywords[
							datesGlobalDataAreaChartTopKeywords.length - 1
						].substring(0, 2)
					) -
						1 ==
						today.getMonth()
				) {
					datesGlobalDataAreaChartTopKeywords[
						datesGlobalDataAreaChartTopKeywords.length - 1
					] =
						datesGlobalDataAreaChartTopKeywords[
							datesGlobalDataAreaChartTopKeywords.length - 1
						] + " (en cours)";
				}
				this.globalDataAreaChartTopKeywords = this.setLineAreaChartOptionsV2(
					chartParamTopKeywords,
					datesGlobalDataAreaChartTopKeywords,
					"globalDataChartTopKeywords"
				);
				console.timeEnd("getDataPerDate");
				resolve(true);
			});
		},

		getDataPerDateKeywords(completeRefresh) {
			return new Promise((resolve) => {
				let chartParamKeywords = {
					keys: { data: [], name: "key" },
					imp: { data: [], name: "Impressions" },
					clicks: { data: [], name: "Clics" },
					ctr: { data: [], name: "CTR" },
					pos: { data: [], name: "Position Moyenne" },
				};

				let xaxis = [];
				let fromDate = new Date(this.fromDate);
				let toDate = new Date(this.toDate);
				let startMonth = fromDate.getMonth();
				let startYear = fromDate.getFullYear();
				while (startYear <= toDate.getFullYear()) {
					if (startYear < toDate.getFullYear()) {
						while (startMonth <= 11) {
							if (startMonth + 1 < 10) {
								xaxis.push(`${startYear}-0${startMonth + 1}`);
							} else {
								xaxis.push(`${startYear}-${startMonth + 1}`);
							}
							startMonth = startMonth + 1;
						}
					} else {
						while (startMonth <= toDate.getMonth()) {
							if (startMonth + 1 < 10) {
								xaxis.push(`${startYear}-0${startMonth + 1}`);
							} else {
								xaxis.push(`${startYear}-${startMonth + 1}`);
							}
							startMonth = startMonth + 1;
						}
					}

					startMonth = 0;
					startYear = startYear + 1;
				}

				let globalSiteDataKeywords = {
					clicks: 0,
					impressions: 0,
					ctr: 0,
					position: 0,
				};

				this.globalKeywordLength = 0;
				for (let date of xaxis) {
					let clicks = 0;
					let impressions = 0;
					let position = 0;
					let ctr = 0;

					let keywordList = [];
					let year = date.substring(0, 4);
					let month = parseInt(date.substring(5, 7)) - 1;

					if (
						this.keywordData &&
						this.keywordData[year] &&
						this.keywordData[year][month] != undefined
					) {
						for (let keyword of this.keywordData[year][month]) {
							if (!keywordList.includes(keyword.keyword)) {
								this.globalKeywordLength += 1;
								keywordList.push(keyword.keyword);
							}
							clicks = keyword ? clicks + keyword.clicks : clicks;
							impressions = keyword
								? impressions + keyword.impressions
								: impressions;
							position = keyword ? position + keyword.position : position;
						}
					}
					position =
						keywordList.length > 0 ? position / keywordList.length : 100; // ATTENTION A RECALCULER
					position = position === 0 ? 100 : position;
					ctr = (clicks / impressions) * 100;
					ctr = isNaN(ctr) ? 0 : ctr;

					// chartParam
					chartParamKeywords.clicks.data.push(Math.trunc(clicks));
					chartParamKeywords.imp.data.push(Math.trunc(impressions));
					chartParamKeywords.pos.data.push(Math.trunc(position));
					chartParamKeywords.ctr.data.push(parseFloat(ctr.toFixed(2)));
					/*
					 *  globalSiteDataKeywords
					 * globalSiteDataKeywords.clicks = globalSiteDataKeywords.clicks + Math.trunc(clicks);
					 */
					globalSiteDataKeywords.clicks = this.globalSiteDataKeywords.clicks;
					globalSiteDataKeywords.impressions =
						globalSiteDataKeywords.impressions + Math.trunc(impressions);
					globalSiteDataKeywords.position =
						isNaN(globalSiteDataKeywords.position) ||
						globalSiteDataKeywords.position == null
							? 100
							: globalSiteDataKeywords.position + Math.trunc(position);
				}
				this.globalTotalPos = globalSiteDataKeywords.position;
				globalSiteDataKeywords.position =
					globalSiteDataKeywords.position / xaxis.length;
				globalSiteDataKeywords.ctr = parseFloat(
					(
						(globalSiteDataKeywords.clicks /
							globalSiteDataKeywords.impressions) *
						100
					).toFixed(2)
				);

				if (chartParamKeywords && chartParamKeywords.pos.data.length >= 2) {
					this.averagePositionEvolution.value =
						chartParamKeywords.pos.data[
							chartParamKeywords.pos.data.length - 1
						] -
						chartParamKeywords.pos.data[chartParamKeywords.pos.data.length - 2];
					this.averagePositionEvolution.statistics =
						chartParamKeywords.pos.data[chartParamKeywords.pos.data.length - 1];
					if (this.averagePositionEvolution.value == 0) {
						this.averagePositionEvolution.color = "grey";
						this.averagePositionEvolution.itext = "=";
					} else if (this.averagePositionEvolution.value < 0) {
						this.averagePositionEvolution.color = "success";
						this.averagePositionEvolution.icon = "icon-arrow-up-right";
					} else {
						this.averagePositionEvolution.color = "danger";
						this.averagePositionEvolution.icon = "icon-arrow-down-right";
					}
				}
				this.globalSiteDataKeywords = [];
				this.globalSiteDataKeywords = globalSiteDataKeywords;
				let datesGlobalDataAreaChartKeywords = xaxis.map((xdate) =>
					xdate.split("-").reverse().join("/")
				);
				let today = new Date(Date.now());
				if (
					toDate.getFullYear() == today.getFullYear() &&
					toDate.getMonth() == today.getMonth()
				)
					datesGlobalDataAreaChartKeywords[
						datesGlobalDataAreaChartKeywords.length - 1
					] =
						datesGlobalDataAreaChartKeywords[
							datesGlobalDataAreaChartKeywords.length - 1
						] + " (en cours)";
				this.globalDataAreaChartKeywords = null;
				this.globalDataAreaChartKeywords = this.setLineAreaChartOptionsV2(
					chartParamKeywords,
					datesGlobalDataAreaChartKeywords,
					"globalDataChartKeywords"
				);
				if (completeRefresh) {
					this.getImpComparisonChartOptions(this.brandData).then(() => {
						resolve(true);
					});
				} else {
					resolve(true);
				}
			});
		},

		/**
		 * Get the impression comparison chart option
		 * @param {Array<number>} data - List of number
		 */
		getImpComparisonChartOptions(data) {
			return new Promise((resolve) => {
				console.time("getImpComparisonChartOptions");
				if (this.globalSiteDataKeywords.impressions || data.impressions) {
					let globalImp = this.globalSiteDataKeywords.impressions
						? this.globalSiteDataKeywords.impressions
						: 0;
					let dataImp = data.impressions ? data.impressions : 0;
					let genericImpressions = globalImp - dataImp;
					console.time("getImpComparisonChartOptions1");
					genericImpressions = genericImpressions < 0 ? 0 : genericImpressions;
					this.impComparisonChartOptions = this.setColumnChartOptions(
						"Répartition des impressions",
						dataImp,
						genericImpressions,
						"Marque",
						"Générique",
						"Répartition des impressions"
					);
					console.timeEnd("getImpComparisonChartOptions1");
					console.timeEnd("getImpComparisonChartOptions");
					resolve(this.impComparisonChartOptions);
				} else {
					console.time("getImpComparisonChartOptions2");
					this.impComparisonChartOptions = this.setColumnChartOptions(
						"Répartition des impressions",
						0,
						0,
						"Marque",
						"Générique",
						"Répartition des impressions"
					);
					console.timeEnd("getImpComparisonChartOptions2");
					console.timeEnd("getImpComparisonChartOptions");
					resolve(this.impComparisonChartOptions);
				}
			});
		},

		getTopKeywords() {
			return new Promise((resolve, reject) => {
				console.time("getTopKeywords");
				this.$http
					.get(
						this.apiUrl + "society/getTopKeywords/" + this.selectedSociety.id
					)
					.then((result) => {
						let keywords = [];
						for (let keyword of result.data) {
							keywords.push(keyword.keyword);
						}
						this.topKeywords = keywords;
						console.timeEnd("getTopKeywords");
						resolve(keywords);
					})
					.catch((err) => reject(err));
			});
		},

		getCompetitors() {
			return new Promise((resolve, reject) => {
				console.time("getCompetitors");
				this.$http
					.get(
						this.apiUrl + "society/getCompetitors/" + this.selectedSociety.id
					)
					.then((result) => {
						let competitors = [];
						let competitorsId = [];
						let competitorsColor = [];
						let colorIterator = 1;
						let colorIteratorMax = this.colors.length;
						for (let competitor of result.data) {
							if (!competitors.includes(competitor.url)) {
								competitorsColor.push(this.colors[colorIterator]);
								colorIterator =
									colorIterator + 1 >= colorIteratorMax ? 1 : colorIterator + 1;
								competitors.push(competitor.url);
								competitorsId.push(competitor.id);
							}
						}
						this.competitors = competitors;
						this.competitorsId = competitorsId;
						this.competitorsColor = competitorsColor;
						this.competitorsName = competitors.map((row) => {
							let rowArray = row.split(".");
							return rowArray.length / 2 <= 1 ? rowArray[0] : rowArray[1];
						});
						console.timeEnd("getCompetitors");
						resolve([competitors, null]);
					})
					.catch((err) => reject(err));
			});
		},

		getCompetitorsFavicon() {
			return new Promise((resolve) => {
				let competitorsFaviconRequests = [];
				let competitorsFavicon = [];
				for (let competitor of this.competitorsId) {
					competitorsFaviconRequests.push(
						this.getCompetitorFavicon(competitor)
					);
				}
				Promise.all(competitorsFaviconRequests).then((responses) => {
					for (let row of responses) {
						competitorsFavicon.push(row);
					}
					this.competitorsFavicon = competitorsFavicon;
					resolve(competitorsFavicon);
				});
			});
		},

		getBrands() {
			return new Promise((resolve, reject) => {
				console.time("getBrands");
				this.$http
					.get(this.apiUrl + "society/getBrands/" + this.selectedSociety.id)
					.then((result) => {
						let brands = [];
						if (result.data.length > 0) {
							brands = [...result.data];
						}
						this.brands = brands;
						console.timeEnd("getBrands");
						resolve(brands);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},

		getBrandsPagesData(selectedSociety, fromDate, toDate) {
			return new Promise((resolve, reject) => {
				this.$http
					.get(
						this.apiUrl +
							"webmaster/gscPageDataKw/" +
							selectedSociety.id +
							"/" +
							fromDate.substring(0, 4) +
							"/" +
							toDate.substring(0, 4)
					)
					.then((result) => {
						let brands_pages_data = [];
						if (result.data.length > 0) {
							brands_pages_data = [...result.data];
						}
						// //console.log("brands_pages_data", result)
						this.brandsPagesData = brands_pages_data;
						resolve(brands_pages_data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},

		getSeoValueByKeywordsForSociety(
			year,
			month,
			setTopKeywordsSEOValueByKeyword = false,
			previousMonthCounter = 12
		) {
			return new Promise((resolve) => {
				this.$http
					.get(
						this.apiUrl +
							"georanker/seovaluebykeyword/" +
							this.selectedSociety.id +
							"/" +
							year +
							"/" +
							month
					)
					.then((result) => {
						console.time("getSeoValueByKeywordsForSociety");
						let seoValue = 0;

						if (result.data.length > 0) {
							console.time("getSeoValueByKeywordsForSociety for loop");
							// //console.log("getSeoValueByKeywordsForSociety SeoValue Start: ", seoValue)
							for (let i = 0; i < result.data.length; i++) {
								let foundVolumeData = this.topKeywordListingFull.data
									? this.topKeywordListingFull.data.findIndex(
											(keyword) => keyword.keyword == result.data[i].keyword
									  )
									: -1;
								if (foundVolumeData >= 0 && setTopKeywordsSEOValueByKeyword) {
									this.topKeywordListingFull.data[foundVolumeData].volume =
										result.data[i].volume;
								}
								seoValue += result.data[i] ? result.data[i].value : 0;
								// //console.log("SeoValue ", result.data[i].keyword,": ", seoValue)
							}
							// //console.log("getSeoValueByKeywordsForSociety SeoValue End: ", seoValue)
							console.timeEnd("getSeoValueByKeywordsForSociety for loop");

							if (setTopKeywordsSEOValueByKeyword) {
								//console.log("getSeoValueByKeywordsForSociety setTopKeywordsSEOValueByKeyword TRUE");
								console.time("setTopKeywordsSEOValueByKeyword result.data");
								let topkeywordsCounter = [...this.topKeywords];
								//console.log("getSeoValueByKeywordsForSociety setTopKeywordsSEOValueByKeyword result.data.length > 0");

								this.topKeywordsSEOValueByKeyword = result.data.map((row) => {
									row.position = row.position < 1 ? 100 : row.position;
									let keywordDataYearKeys = Object.keys(this.keywordData);
									if (keywordDataYearKeys.length > 0) {
										// for(let i = 0; i < keywordDataYearKeys.length; i++){
										if (
											this.keywordData[keywordDataYearKeys[0]] &&
											this.keywordData[keywordDataYearKeys[0]].length > 0 &&
											this.keywordData[keywordDataYearKeys[0]][month - 1]
										) {
											let keywordIndexFound = this.keywordData[
												keywordDataYearKeys[0]
											][month - 1].findIndex(
												(kwdata) => kwdata.keyword == row.keyword
											);
											if (keywordIndexFound >= 0) {
												row.clicks =
													this.keywordData[keywordDataYearKeys[0]][month - 1][
														keywordIndexFound
													].clicks;
											}
										}
										// }
									}
									// //console.log("topKeywordsSEOValueByKeyword", row);
									return row;
								});
								for (
									let i = 0;
									i < this.topKeywordsSEOValueByKeyword.length;
									i++
								) {
									let topkeywordsCounterIndex = topkeywordsCounter.indexOf(
										this.topKeywordsSEOValueByKeyword[i].keyword
									);
									if (topkeywordsCounterIndex >= 0) {
										topkeywordsCounter.splice(topkeywordsCounterIndex, 1);
									}
								}
								if (topkeywordsCounter.length > 0) {
									for (let i = 0; i < topkeywordsCounter.length; i++) {
										let cpc = this.topKeywordsSERPComparison.keywords_info[
											topkeywordsCounter[i]
										]
											? this.topKeywordsSERPComparison.keywords_info[
													topkeywordsCounter[i]
											  ].cpc
											: 0;
										let volume = this.topKeywordsSERPComparison.keywords_info[
											topkeywordsCounter[i]
										]
											? this.topKeywordsSERPComparison.keywords_info[
													topkeywordsCounter[i]
											  ].volume
											: 0;
										let kd = this.topKeywordsSERPComparison.keywords_info[
											topkeywordsCounter[i]
										]
											? this.topKeywordsSERPComparison.keywords_info[
													topkeywordsCounter[i]
											  ].kd
											: 0;
										// //console.log("kd", topkeywordsCounter[i], kd);
										this.topKeywordsSEOValueByKeyword.push({
											keyword: topkeywordsCounter[i],
											cpc: cpc,
											kd: kd,
											position: 101,
											volume: volume,
											value: 0,
											click: -1,
										});
									}
								}
								console.timeEnd("setTopKeywordsSEOValueByKeyword result.data");
							} else {
								//console.log("getSeoValueByKeywordsForSociety setTopKeywordsSEOValueByKeyword FALSE");
							}
							console.timeEnd("getSeoValueByKeywordsForSociety");
							resolve(seoValue);
						} else if (
							this.seoValueByKeywordPreviousMonthWarning == false &&
							previousMonthCounter > 0
						) {
							//console.log("getSeoValueByKeywordsForSociety setTopKeywordsSEOValueByKeyword result.data.length <= 0");
							let previousMonth = month - 1;
							let previousYear = previousMonth < 1 ? year - 1 : year;
							previousMonth = previousMonth < 1 ? 12 : previousMonth;
							this.getSeoValueByKeywordsForSociety(
								previousYear,
								previousMonth,
								setTopKeywordsSEOValueByKeyword,
								previousMonthCounter - 1
							)
								.then((previousMonthResult) => {
									this.seoValueByKeywordPreviousMonthWarning = true;
									console.timeEnd("getSeoValueByKeywordsForSociety");
									resolve(previousMonthResult);
								})
								.catch((err) => {
									//console.log(err);
									console.timeEnd("getSeoValueByKeywordsForSociety");
									resolve(0);
								});
						} else {
							if (setTopKeywordsSEOValueByKeyword) {
								//console.log("getSeoValueByKeywordsForSociety setTopKeywordsSEOValueByKeyword TRUE");
								console.time("setTopKeywordsSEOValueByKeyword result.data");
								let topkeywordsCounter = [...this.topKeywords];
								//console.log("getSeoValueByKeywordsForSociety setTopKeywordsSEOValueByKeyword result.data.length > 0");
								if (topkeywordsCounter.length > 0) {
									for (let i = 0; i < topkeywordsCounter.length; i++) {
										let cpc = this.topKeywordsSERPComparison.keywords_info[
											topkeywordsCounter[i]
										]
											? this.topKeywordsSERPComparison.keywords_info[
													topkeywordsCounter[i]
											  ].cpc
											: 0;
										let volume = this.topKeywordsSERPComparison.keywords_info[
											topkeywordsCounter[i]
										]
											? this.topKeywordsSERPComparison.keywords_info[
													topkeywordsCounter[i]
											  ].volume
											: 0;
										let kd = this.topKeywordsSERPComparison.keywords_info[
											topkeywordsCounter[i]
										]
											? this.topKeywordsSERPComparison.keywords_info[
													topkeywordsCounter[i]
											  ].kd
											: 0;
										this.topKeywordsSEOValueByKeyword.push({
											keyword: topkeywordsCounter[i],
											cpc: cpc,
											kd: kd,
											position: 101,
											volume: volume,
											value: 0,
											click: -1,
										});
									}
								}
								console.timeEnd("setTopKeywordsSEOValueByKeyword result.data");
							}
							console.timeEnd("getSeoValueByKeywordsForSociety");
							resolve(0);
						}
					})
					.catch((err) => {
						//console.log(err);
						console.timeEnd("getSeoValueByKeywordsForSociety");
						resolve(0);
					});
				/*
				 * let timeName = "georanker/getKD3" + Math.floor(Math.random() * 10)
				 * console.time(timeName)
				 * this.$http.post(this.apiUrl + "georanker/getKD/" + this.selectedSociety.id)
				 * .then(res=>{
				 *   for(let i = 0; i < this.topKeywordsSEOValueByKeyword.length; i++){
				 *     this.topKeywordsSEOValueByKeyword[i]["kd"] = res.data[this.topKeywordsSEOValueByKeyword[i].keyword]
				 *   }
				 *   console.timeEnd(timeName)
				 * })
				 * .catch(errr => {
				 *   //console.log("georanker/getKD: ",errr)
				 * })
				 */
			});
		},

		getGlobalSeoValuesForSociety(year, month) {
			return new Promise((resolve) => {
				this.$http
					.get(
						this.apiUrl +
							"georanker/seovalueglobal/" +
							this.selectedSociety.id +
							"/" +
							year +
							"/" +
							month
					)
					.then((result) => {
						resolve(result.data);
					})
					.catch(() => {
						resolve([]);
					});
			});
		},

		getEstimatedCTRfromPosition(position) {
			switch (position) {
				case 1:
					return 0.3173;
				case 2:
					return 0.2471;
				case 3:
					return 0.1866;
				case 4:
					return 0.136;
				case 5:
					return 0.0951;
				case 6:
					return 0.0623;
				case 10:
					return 0.05;
				case position < 10:
					return (1.30667 - 0.0766 * position) / 100;
				case position < 100:
					return (5.555 - 0.055 * position) / 100;
				default:
					return 0;
			}
		},

		getAverageCTRForPosition(position) {
			let foundIndex = this.allCtrAverages.ranges.findIndex(
				(range) => range[0] >= position && range[1] <= position
			);
			if (foundIndex >= 0) {
				return this.allCtrAverages.averages[foundIndex];
			}
			return 0;
		},

		getKeywordPotential(position, clicks, impressions) {
			/*
			 * Moyenne des CTR dans la fourchette qui ne sont pas Marque et qui ont plus de 10 impressions --- OK allCtrAverages
			 * Si les occurences sont trop basse, inférer le % CTRT en fonction de l'écart avec les autres fourchettes --- occurencies < 10
			 * Calculer le potentiel CTR_Ecart * Impressions * position
			 */

			// if(clicks > 0) //console.log(clicks, impressions)
			if (impressions < 100) {
				return 0;
			}
			const ctr = clicks > 0 ? clicks / impressions : 0;
			const estimatedCTR = this.getAverageCTRForPosition(position);
			// if(estimatedCTR > 0) //console.log("estimatedCTR", estimatedCTR, position)
			let potential =
				ctr > 0 && estimatedCTR > 0
					? Math.round(this.computeDifferenceForPotential(ctr, estimatedCTR))
					: 0;
			// if(potential > 0) //console.log(potential, position, clicks, impressions, ctr, estimatedCTR)
			return potential;
		},

		getFaviconSource(url, type = "all") {
			if (type == "all") {
				if (url == this.getUrlDomain(this.selectedSociety.gsc_url)) {
					return this.societyFavicon;
				} else {
					type = "competitor";
				}
			}
			if (type == "competitor") {
				let foundCompetitorId = this.competitors.findIndex(
					(competitor) => competitor == url
				);
				if (foundCompetitorId >= 0) {
					let foundCompetitorImg = this.competitorsFavicon[foundCompetitorId];
					if (foundCompetitorImg) {
						if (foundCompetitorImg != "") {
							return foundCompetitorImg;
						}
					}
				}
			}
			if (type == "society") {
				return this.societyFavicon;
			}
			return "";
		},

		getSocietyFavicon(society_id) {
			return new Promise((resolve) => {
				this.$http
					.get(this.apiUrl + "society/getFavicon/" + society_id + "/society")
					.then((image) => {
						this.societyFavicon = image.data;
						resolve(image.data);
					})
					.catch(() => {
						resolve("");
					});
			});
		},

		getCompetitorFavicon(competitor_id) {
			return new Promise((resolve) => {
				this.$http
					.get(
						this.apiUrl + "society/getFavicon/" + competitor_id + "/competitor"
					)
					.then((image) => {
						resolve(image.data);
					})
					.catch(() => {
						resolve("");
					});
			});
		},

		// 0003 - Display / Show

		showLineChartPopup(params) {
			this.lineChartPopup = this.setLineAreaChartOptionsV2(
				params[0],
				params[1],
				"popupDataChartTopKeywords"
			);
			if (this.lineChartPopupBool == true) this.lineChartPopupBool = false;
			this.lineChartPopupBool = true;
		},
		showKeywordsDiffPopup() {
			//console.log("showKeywordsDiffPopup");
			/*
			 * GET THIS MONTH KEYWORD LIST -> TO DATE
			 * let dateObject = new Date(this.toDate)
			 */

			/*
			 * let year = dateObject.getFullYear()
			 * let month = dateObject.getMonth()
			 */

			/*
			 * month = month - 1
			 * if(month < 0){
			 *     month = 11
			 *     year = (parseInt(year) - 1).toString()
			 * }
			 */

			this.keywordsDiffPopupDataNew = [];
			this.keywordsDiffPopupDataDelete = [];
			// GET PREVIOUS MONTH KEYWORD LIST -> TO DATE - 1

			// COMPARE

			for (let keyword in this.topKeywordsSERPComparison.keywords) {
				let actual_month_index =
					this.topKeywordsSERPComparison.dates.length - 1;
				let last_month_index = this.topKeywordsSERPComparison.dates.length - 2;
				let position = this.topKeywordsSERPComparison.keywords[keyword][
					this.topKeywordsSERPComparison.domains[0]
				]
					? this.topKeywordsSERPComparison.keywords[keyword][
							this.topKeywordsSERPComparison.domains[0]
					  ][actual_month_index]
					: 0;
				let last_month_position = this.topKeywordsSERPComparison.keywords[
					keyword
				][this.topKeywordsSERPComparison.domains[0]]
					? this.topKeywordsSERPComparison.keywords[keyword][
							this.topKeywordsSERPComparison.domains[0]
					  ][last_month_index]
					: 0;
				let volume = this.topKeywordsSERPComparison.keywords_info[keyword]
					? this.topKeywordsSERPComparison.keywords_info[keyword].volume
					: 0;
				let cpc = this.topKeywordsSERPComparison.keywords_info[keyword]
					? this.topKeywordsSERPComparison.keywords_info[keyword].cpc
					: 0;
				if (
					position > 0 &&
					position < 100 &&
					(last_month_position <= 0 || last_month_position >= 100)
				) {
					this.keywordsDiffPopupDataNew.push({
						keyword: keyword,
						position: position,
						volume: volume,
						cpc: cpc,
					});
				} else if (
					last_month_position > 0 &&
					last_month_position < 100 &&
					(position <= 0 || position >= 100)
				) {
					this.keywordsDiffPopupDataDelete.push({
						keyword: keyword,
						position: last_month_position,
						volume: volume,
						cpc: cpc,
					});
				}
			}
			// SHOW DIFF POPUP : TODO CREATE POPUP
			this.keywordsDiffPopup = true;
		},
		displayTransactionPopup() {
			this.transactionPopupActive = true;
		},
		displayConversionPopup() {
			this.conversionPopupActive = true;
		},

		displayKeywordListPopup(argYear, argMonth) {
			this.selectedDate = {
				year: argYear,
				month: argMonth,
				monthIndex: parseInt(argMonth) - 1,
			};
			this.keywordListPopup = true;
		},

		displayTopKeywordListPopup(argYear, argMonth) {
			this.selectedDate = {
				year: argYear,
				month: argMonth,
				monthIndex: parseInt(argMonth) - 1,
			};
			let topKeywordListing = [];
			let dateIndex = this.topKeywordsSERPComparison.dates.findIndex(
				(date) => date == `${argYear}-${argMonth}`
			);
			if (dateIndex >= 0) {
				for (let keyword in this.topKeywordsSERPComparison.keywords) {
					let position = this.topKeywordsSERPComparison.keywords[keyword][
						this.topKeywordsSERPComparison.domains[0]
					]
						? this.topKeywordsSERPComparison.keywords[keyword][
								this.topKeywordsSERPComparison.domains[0]
						  ][dateIndex]
						: 0;
					if (position > 0 && position < 100) {
						topKeywordListing.push({
							keyword: keyword,
							position: position,
						});
					}
				}
			}
			this.topKeywordListing = topKeywordListing;
			this.topKeywordListPopup = true;
		},

		displayBrandListPopup() {
			console.time("displayBrandListPopup");
			let startYear = this.fromDate.substring(0, 4);
			let toYear = this.toDate.substring(0, 4);
			let startMonth = this.fromDate.substring(5, 7);
			let toMonth = this.toDate.substring(5, 7);

			let brandListing = [];

			let brandListingTotal = {
				clicks: 0,
				impressions: 0,
				position: 0,
				counter: 0,
				averagePosition: 0,
				averageCTR: 0,
			};

			for (let keyword of this.brands) {
				let trimKeyword = keyword.trim();
				if (this.brandData && this.brandData[trimKeyword]) {
					for (let year in this.brandData[trimKeyword]) {
						if (this.brandData[trimKeyword][year]) {
							for (let month in this.brandData[trimKeyword][year]) {
								if (this.brandData[trimKeyword][year][month]) {
									if (
										(year == startYear &&
											startYear != toYear &&
											parseInt(month) + 1 >= parseInt(startMonth)) ||
										(year == startYear &&
											startYear == toYear &&
											parseInt(month) + 1 >= parseInt(startMonth) &&
											parseInt(month) + 1 <= parseInt(toMonth)) ||
										(year == toYear &&
											startYear != toYear &&
											parseInt(month) + 1 <= parseInt(toMonth)) ||
										(year > startYear && year < toYear)
									) {
										for (let foundBrandKeyword of this.brandData[trimKeyword][
											year
										][month]) {
											let foundIndex = brandListing.findIndex(
												(row) => row.keyword == foundBrandKeyword.keyword
											);
											if (foundIndex >= 0) {
												brandListing[foundIndex].clicks +=
													foundBrandKeyword.clicks;
												brandListing[foundIndex].impressions +=
													foundBrandKeyword.impressions;
												brandListing[foundIndex].position +=
													foundBrandKeyword.position;
												brandListing[foundIndex].counter += 1;

												brandListingTotal.clicks += foundBrandKeyword.clicks;
												brandListingTotal.impressions +=
													foundBrandKeyword.impressions;
												brandListingTotal.position +=
													foundBrandKeyword.position;
												brandListingTotal.counter += 1;
											} else {
												brandListing.push({
													keyword: foundBrandKeyword.keyword,
													clicks: foundBrandKeyword.clicks,
													impressions: foundBrandKeyword.impressions,
													position: foundBrandKeyword.position,
													counter: 1,
												});
												brandListingTotal.clicks += foundBrandKeyword.clicks;
												brandListingTotal.impressions +=
													foundBrandKeyword.impressions;
												brandListingTotal.position +=
													foundBrandKeyword.position;
												brandListingTotal.counter += 1;
											}
										}
									}
								}
							}
						}
					}
				}
			}

			for (let brandKeyword of brandListing) {
				brandKeyword.ctr =
					brandKeyword.impressions > 0 && brandKeyword.clicks > 0
						? (brandKeyword.clicks / brandKeyword.impressions) * 100
						: 0;
			}

			brandListingTotal.averagePosition =
				brandListingTotal.counter > 0
					? brandListingTotal.position / brandListingTotal.counter
					: 0;
			brandListingTotal.averageCTR =
				brandListingTotal.impressions > 0
					? brandListingTotal.clicks / brandListingTotal.impressions
					: 0;
			brandListing.sort((a, b) => {
				let keywordA = a.impressions;
				let keywordB = b.impressions;
				let comparison = 0;
				if (keywordA < keywordB) {
					comparison = 1;
				} else if (keywordA > keywordB) {
					comparison = -1;
				}
				return comparison;
			});

			this.brandKeywordsListing = brandListing;
			console.timeEnd("displayBrandListPopup");
			return brandListingTotal;
		},

		showSocietyPopup() {
			//Initialisation des données pour le popup
			this.showSocietyPopupActive = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopupActive,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		showSocietyModificationAnalyticsPopup() {
			this.modifiedAnalytics = this.selectedSociety.analytics_id;
			this.showSocietyModificationAnalyticsPopupActive = true;
		},

		showSocietyModificationGscPopup() {
			this.modifiedGSC = this.selectedSociety.gsc_url;
			this.showSocietyModificationGscPopupActive = true;
		},

		showBrandsPopup() {
			this.$refs.topKeywordsFilter.showBrandEditorPopup();
		},

		showCompetitorsPopup() {
			this.$refs.topKeywordsFilter.showCompetitorEditorPopup();
		},

		showTopKeywordsPopup() {
			this.$refs.topKeywordsFilter.showTopKeywordEditorPopup();
		},

		createValidationPopup(propsData) {
			let ComponentClass = Vue.extend(ValidationPopup);
			//console.log("ComponentClass");
			//console.log(ComponentClass);
			let createdValidationPopup = new ComponentClass({ propsData });
			createdValidationPopup.$on("option-one", () => {
				this.acceptValidationFunction(this.valueValidationPopup);
			});
			createdValidationPopup.$on("option-two", () => {
				this.declineValidationFunction();
			});
			createdValidationPopup.$mount();
			this.$refs.popupContainer.appendChild(createdValidationPopup.$el);
		},

		addBrandValidation(keyword) {
			if (this.boolValidationPopup == true) this.boolValidationPopup = false;
			this.valueValidationPopup = keyword;
			this.titleValidationPopup = `Validation d'ajout de la Marque : ${keyword[0]}`;
			this.acceptValidationFunction = this.addBrand;
			this.declineValidationFunction = this.declineValidation;
			this.boolValidationPopup = true;
			this.createValidationPopup({
				title: this.titleValidationPopup,
				optionOneText: "Ajouter",
				optionTwoText: "Annuler",
				isActive: this.boolValidationPopup,
			});
		},

		addTopKeywordValidation(keyword) {
			//console.log("addTopKeywordValidation");
			if (this.boolValidationPopup == true) this.boolValidationPopup = false;
			this.valueValidationPopup = keyword;
			this.titleValidationPopup = `Validation d'ajout du Top Keyword : ${keyword}`;
			this.acceptValidationFunction = this.addTopKeyword;
			this.declineValidationFunction = this.declineValidation;
			this.boolValidationPopup = true;
			this.createValidationPopup({
				title: this.titleValidationPopup,
				optionOneText: "Ajouter",
				optionTwoText: "Annuler",
				isActive: this.boolValidationPopup,
			});
		},

		declineValidation() {
			this.valueValidationPopup = null;
			this.titleValidationPopup = "";
			this.acceptValidationFunction = function () {};
			this.declineValidationFunction = function () {};
		},

		removeBrandValidation(keyword) {
			if (this.boolValidationPopup == true) this.boolValidationPopup = false;
			this.valueValidationPopup = keyword;
			this.titleValidationPopup = `Validation de suppresion de la Marque : ${keyword}`;
			this.acceptValidationFunction = this.removeBrand;
			this.declineValidationFunction = this.declineValidation;
			this.boolValidationPopup = true;
			this.createValidationPopup({
				title: this.titleValidationPopup,
				optionOneText: "Supprimer",
				optionTwoText: "Annuler",
				isActive: this.boolValidationPopup,
			});
		},

		removeTopKeywordValidation(keyword) {
			if (this.boolValidationPopup == true) this.boolValidationPopup = false;
			this.valueValidationPopup = keyword;
			this.titleValidationPopup = `Validation de suppresion du Top Keyword : ${keyword}`;
			this.acceptValidationFunction = this.removeTopKeyword;
			this.declineValidationFunction = this.declineValidation;
			this.boolValidationPopup = true;
			this.createValidationPopup({
				title: this.titleValidationPopup,
				optionOneText: "Supprimer",
				optionTwoText: "Annuler",
				isActive: this.boolValidationPopup,
			});
		},

		async addBrand(keyword) {
			for (let i = 0; i < keyword.length; i++) {
				if (i == 0) {
					this.$vs.notify({
						title: "Enregistrement en cours",
						text: "Veuillez patienter.",
					});
				}
				let updatedBrands = [...this.brands];
				updatedBrands.push(keyword[i]);
				await this.updateBrands(updatedBrands.join(","));
				if (i == keyword.length - 1) {
					this.$vs.notify({
						title: "Succès",
						text: "Marque ajoutée avec succès.",
					});
				}
			}
		},

		removeBrand(keyword) {
			let updatedBrands = [...this.brands];
			let foundBrandIndex = updatedBrands.indexOf(keyword);
			if (foundBrandIndex >= 0) {
				updatedBrands.splice(foundBrandIndex, 1);
				this.updateBrands(updatedBrands.join(","));
				this.$vs.notify({
					title: "Succès",
					text: "Marque ajoutée avec succès.",
				});
			} else {
				this.$vs.notify({
					title: "Erreur",
					text: "Marque introuvable.",
				});
			}
		},

		addTopKeyword(keyword) {
			let updatedTopKeywords = [...this.topKeywords];
			updatedTopKeywords.push(keyword);
			this.updateTopKeywords(updatedTopKeywords.join(","));
			this.$vs.notify({
				title: "Succès",
				text: "Top keyword ajouté avec succès.",
			});
		},

		removeTopKeyword(keyword) {
			let updatedTopKeywords = [...this.topKeywords];
			let foundTopKeywordsIndex = updatedTopKeywords.indexOf(keyword);
			if (foundTopKeywordsIndex >= 0) {
				updatedTopKeywords.splice(foundTopKeywordsIndex, 1);
				this.updateTopKeywords(updatedTopKeywords.join(","));
				this.$vs.notify({
					title: "Succès",
					text: "Top keyword ajouté avec succès.",
				});
			} else {
				this.$vs.notify({
					title: "Erreur",
					text: "Top keyword introuvable.",
				});
			}
		},

		/*
		 * 0004 - Refresh
		 * refreshBrandsPages -> getBrandsPagesData ; getPageRankData ; setBrandsPages
		 * refreshKeywordData -> getKeywordData ; getDataPerDateKeywords ; setStackedBarChartOptionsKeywords ; getBrandData ; getTopKeywordData ; getTopKeywordData
		 * refreshTopKeywords -> getTopKeywords ; getTopKeywordData
		 * refreshBrands -> getBrands ; getBrandData
		 * refreshCompetitors -> getCompetitorsFavicon ; buildTopKeywordsSERPComparison
		 * refreshDependentData -> refreshBrandsPages ; refreshTopKeywords ; refreshBrands ; refreshCompetitors
		 * refreshIndependentData -> getConversionsOrRevenues ; getSocietyFavicon ; getApiLastUpdate
		 * refreshAllData -> refreshIndependentData ; refreshDependentData
		 * refreshGSCData -> refreshBrandsPages ; refreshKeywordData
		 */
		refreshBrandsPages() {
			return new Promise((resolve, reject) => {
				for (
					let i = 0;
					i < this.loadersIds.refreshBrandsPages.noslug.length;
					i++
				) {
					/*
					 * if(this.$refs.refreshBrandsPages){
					 * //console.log("this.loadersIds.refreshBrandsPages.noslug[i]", this.loadersIds.refreshBrandsPages.noslug[i])
					 * //console.log("this.$refs", this.$refs)
					 * //console.log("this.loadersIds.refreshBrandsPages.position[i]", this.loadersIds.refreshBrandsPages.position[i])
					 */
					if (
						this.loaderStatus[this.loadersIds.refreshBrandsPages.noslug[i]]
							.length < 1 &&
						this.$refs &&
						this.$refs[this.loadersIds.refreshBrandsPages.position[i]]
					) {
						this.$refs[
							this.loadersIds.refreshBrandsPages.position[i]
						].openLoadingContainer(this.loadersIds.refreshBrandsPages.data[i]);
					}
					this.loaderStatus[this.loadersIds.refreshBrandsPages.noslug[i]].push(
						"refreshBrandsPages"
					);
					/*
					 * this.$refs.refreshBrandsPages.openLoadingContainer(id)
					 * }else{
					 *   //console.log("Error: this.$refs.refreshBrandsPages ", this.$refs.refreshBrandsPages)
					 * }
					 */
				}
				let queries = [];
				queries.push(
					this.getBrandsPagesData(
						this.selectedSociety,
						this.fromDate,
						this.toDate
					)
				);
				queries.push(this.getPageRankData());

				Promise.all(queries)
					.then(() => {
						this.setBrandsPages();
						for (
							let i = 0;
							i < this.loadersIds.refreshBrandsPages.noslug.length;
							i++
						) {
							this.loaderStatus[this.loadersIds.refreshBrandsPages.noslug[i]] =
								this.loaderStatus[
									this.loadersIds.refreshBrandsPages.noslug[i]
								].filter((row) => row != "refreshBrandsPages");
							if (
								this.loaderStatus[this.loadersIds.refreshBrandsPages.noslug[i]]
									.length < 1 &&
								this.$refs &&
								this.$refs[this.loadersIds.refreshBrandsPages.position[i]]
							) {
								this.$refs[
									this.loadersIds.refreshBrandsPages.position[i]
								].closeLoadingContainer(
									this.loadersIds.refreshBrandsPages.data[i]
								);
							}
						}
						resolve(true);
					})
					.catch((queriesErrors) => {
						//console.log("refreshBrandsPages", queriesErrors);
						reject(queriesErrors);
					});
			});
		},

		refreshKeywordData(completeRefresh = false) {
			return new Promise((resolve, reject) => {
				for (
					let i = 0;
					i < this.loadersIds.refreshKeywordData.noslug.length;
					i++
				) {
					if (
						this.loaderStatus[this.loadersIds.refreshKeywordData.noslug[i]]
							.length < 1 &&
						this.$refs &&
						this.$refs[this.loadersIds.refreshKeywordData.position[i]]
					)
						this.$refs[
							this.loadersIds.refreshKeywordData.position[i]
						].openLoadingContainer(this.loadersIds.refreshKeywordData.data[i]);
					this.loaderStatus[this.loadersIds.refreshKeywordData.noslug[i]].push(
						"refreshKeywordData"
					);
				}
				this.getKeywordData(this.selectedSociety, this.fromDate, this.toDate)
					.then(() => {
						let queries = [];
						queries.push(this.getDataPerDateKeywords());
						queries.push(this.setStackedBarChartOptionsKeywords());

						if (this.brands && this.brands.length > 0) {
							queries.push(this.getBrandData(completeRefresh));
						}

						if (this.topKeywords && this.topKeywords.length > 0) {
							queries.push(this.getTopKeywordData(completeRefresh));
						}
						Promise.all(queries)
							.then(() => {
								for (
									let i = 0;
									i < this.loadersIds.refreshKeywordData.noslug.length;
									i++
								) {
									this.loaderStatus[
										this.loadersIds.refreshKeywordData.noslug[i]
									] = this.loaderStatus[
										this.loadersIds.refreshKeywordData.noslug[i]
									].filter((row) => row != "refreshKeywordData");
									if (
										this.loaderStatus[
											this.loadersIds.refreshKeywordData.noslug[i]
										].length < 1 &&
										this.$refs &&
										this.$refs[this.loadersIds.refreshKeywordData.position[i]]
									)
										this.$refs[
											this.loadersIds.refreshKeywordData.position[i]
										].closeLoadingContainer(
											this.loadersIds.refreshKeywordData.data[i]
										);
								}
								resolve(true);
							})
							.catch((queriesError) => {
								//console.log("refreshKeywordData Promise.all", queriesError);
								reject(queriesError);
							});
					})
					.catch((queriesErrors) => {
						//console.log("refreshKeywordData", queriesErrors);
						reject(queriesErrors);
					});
			});
		},

		refreshTopKeywords(completeRefresh = false) {
			return new Promise((resolve, reject) => {
				for (
					let i = 0;
					i < this.loadersIds.refreshTopKeywords.noslug.length;
					i++
				) {
					/*
					 * if(this.$refs.refreshTopKeywords){
					 * //console.log(this.loadersIds.refreshTopKeywords.noslug[i])
					 */
					if (
						this.loaderStatus[this.loadersIds.refreshTopKeywords.noslug[i]]
							.length < 1 &&
						this.$refs &&
						this.$refs[this.loadersIds.refreshTopKeywords.position[i]]
					)
						this.$refs[
							this.loadersIds.refreshTopKeywords.position[i]
						].openLoadingContainer(this.loadersIds.refreshTopKeywords.data[i]);
					this.loaderStatus[this.loadersIds.refreshTopKeywords.noslug[i]].push(
						"refreshTopKeywords"
					);
					/*
					 * this.$refs.refreshTopKeywords.openLoadingContainer(id)
					 * }else{
					 *   //console.log("Error: this.$refs.refreshTopKeywords ", this.$refs.refreshTopKeywords)
					 * }
					 */
				}
				this.getTopKeywords()
					.then(() => {
						if (completeRefresh && this.keywordData !== {}) {
							this.getTopKeywordData(completeRefresh).then(() => {
								/*
								 * for(let id of this.loadersIds.refreshTopKeywords.data){
								 *   //console.log(id)
								 *   this.$refs.keywordsGeneral.closeLoadingContainer(id)
								 * }
								 */
								for (
									let i = 0;
									i < this.loadersIds.refreshTopKeywords.noslug.length;
									i++
								) {
									this.loaderStatus[
										this.loadersIds.refreshTopKeywords.noslug[i]
									] = this.loaderStatus[
										this.loadersIds.refreshTopKeywords.noslug[i]
									].filter((row) => row != "refreshTopKeywords");
									if (
										this.loaderStatus[
											this.loadersIds.refreshTopKeywords.noslug[i]
										].length < 1 &&
										this.$refs &&
										this.$refs[this.loadersIds.refreshTopKeywords.position[i]]
									)
										this.$refs[
											this.loadersIds.refreshTopKeywords.position[i]
										].closeLoadingContainer(
											this.loadersIds.refreshTopKeywords.data[i]
										);
								}
								resolve(true);
							});
						} else {
							/*
							 * for(let id of this.loadersIds.refreshTopKeywords.data){
							 *   //console.log(id)
							 *   this.$refs.keywordsGeneral.closeLoadingContainer(id)
							 * }
							 */
							for (
								let i = 0;
								i < this.loadersIds.refreshTopKeywords.noslug.length;
								i++
							) {
								this.loaderStatus[
									this.loadersIds.refreshTopKeywords.noslug[i]
								] = this.loaderStatus[
									this.loadersIds.refreshTopKeywords.noslug[i]
								].filter((row) => row != "refreshTopKeywords");
								if (
									this.loaderStatus[
										this.loadersIds.refreshTopKeywords.noslug[i]
									].length < 1 &&
									this.$refs &&
									this.$refs[this.loadersIds.refreshTopKeywords.position[i]]
								)
									this.$refs[
										this.loadersIds.refreshTopKeywords.position[i]
									].closeLoadingContainer(
										this.loadersIds.refreshTopKeywords.data[i]
									);
							}
							resolve(true);
						}
					})
					.catch((queriesErrors) => {
						//console.log("refreshTopKeywords", queriesErrors);
						reject(queriesErrors);
					});
			});
		},

		refreshBrands(completeRefresh = false) {
			return new Promise((resolve, reject) => {
				for (let i = 0; i < this.loadersIds.refreshBrands.noslug.length; i++) {
					// if(this.$refs.refreshBrands){
					if (
						this.loaderStatus[this.loadersIds.refreshBrands.noslug[i]].length <
							1 &&
						this.$refs &&
						this.$refs[this.loadersIds.refreshBrands.position[i]]
					)
						this.$refs[
							this.loadersIds.refreshBrands.position[i]
						].openLoadingContainer(this.loadersIds.refreshBrands.data[i]);
					this.loaderStatus[this.loadersIds.refreshBrands.noslug[i]].push(
						"refreshBrands"
					);
					/*
					 * this.$refs.refreshBrands.openLoadingContainer(id)
					 * }else{
					 *   //console.log("Error: this.$refs.refreshBrands ", this.$refs.refreshBrands)
					 * }
					 */
				}
				this.getBrands()
					.then(() => {
						if (completeRefresh && this.keywordData !== {}) {
							this.getBrandData(completeRefresh).then(() => {
								for (
									let i = 0;
									i < this.loadersIds.refreshBrands.noslug.length;
									i++
								) {
									this.loaderStatus[this.loadersIds.refreshBrands.noslug[i]] =
										this.loaderStatus[
											this.loadersIds.refreshBrands.noslug[i]
										].filter((row) => row != "refreshBrands");
									if (
										this.loaderStatus[this.loadersIds.refreshBrands.noslug[i]]
											.length < 1 &&
										this.$refs &&
										this.$refs[this.loadersIds.refreshBrands.position[i]]
									)
										this.$refs[
											this.loadersIds.refreshBrands.position[i]
										].closeLoadingContainer(
											this.loadersIds.refreshBrands.data[i]
										);
								}
								resolve(true);
							});
						} else {
							for (
								let i = 0;
								i < this.loadersIds.refreshBrands.noslug.length;
								i++
							) {
								this.loaderStatus[this.loadersIds.refreshBrands.noslug[i]] =
									this.loaderStatus[
										this.loadersIds.refreshBrands.noslug[i]
									].filter((row) => row != "refreshBrands");
								if (
									this.loaderStatus[this.loadersIds.refreshBrands.noslug[i]]
										.length < 1 &&
									this.$refs &&
									this.$refs[this.loadersIds.refreshBrands.position[i]]
								)
									this.$refs[
										this.loadersIds.refreshBrands.position[i]
									].closeLoadingContainer(
										this.loadersIds.refreshBrands.data[i]
									);
							}
							resolve(true);
						}
					})
					.catch((queriesErrors) => {
						//console.log("refreshBrands", queriesErrors);
						reject(queriesErrors);
					});
			});
		},

		refreshCompetitors(completeRefresh = false) {
			return new Promise((resolve, reject) => {
				for (
					let i = 0;
					i < this.loadersIds.refreshCompetitors.noslug.length;
					i++
				) {
					// if(this.$refs.refreshCompetitors){
					if (
						this.loaderStatus[this.loadersIds.refreshCompetitors.noslug[i]]
							.length < 1 &&
						this.$refs &&
						this.$refs[this.loadersIds.refreshCompetitors.position[i]]
					) {
						// //console.log("Open", this.loadersIds.refreshCompetitors.data[i], " in ", this.loadersIds.refreshCompetitors.position[i])
						this.$refs[
							this.loadersIds.refreshCompetitors.position[i]
						].openLoadingContainer(this.loadersIds.refreshCompetitors.data[i]);
					}
					this.loaderStatus[this.loadersIds.refreshCompetitors.noslug[i]].push(
						"refreshCompetitors"
					);
					/*
					 * this.$refs.refreshCompetitors.openLoadingContainer(id)
					 * }else{
					 *   //console.log("Error: this.$refs.refreshCompetitors ", this.$refs.refreshCompetitors)
					 * }
					 */
				}
				this.getCompetitors()
					.then(() => {
						let queries = [];
						queries.push(this.getCompetitorsFavicon());
						queries.push(this.buildTopKeywordsSERPComparison(completeRefresh));
						Promise.all(queries)
							.then(() => {
								for (
									let i = 0;
									i < this.loadersIds.refreshCompetitors.noslug.length;
									i++
								) {
									this.loaderStatus[
										this.loadersIds.refreshCompetitors.noslug[i]
									] = this.loaderStatus[
										this.loadersIds.refreshCompetitors.noslug[i]
									].filter((row) => row != "refreshCompetitors");
									if (
										this.loaderStatus[
											this.loadersIds.refreshCompetitors.noslug[i]
										].length < 1 &&
										this.$refs &&
										this.$refs[this.loadersIds.refreshCompetitors.position[i]]
									) {
										// //console.log("Close", this.loadersIds.refreshCompetitors.data[i], " in ", this.loadersIds.refreshCompetitors.position[i])
										this.$refs[
											this.loadersIds.refreshCompetitors.position[i]
										].closeLoadingContainer(
											this.loadersIds.refreshCompetitors.data[i]
										);
									}
								}
								resolve(true);
							})
							.catch((queriesErrors) => {
								//console.log("refreshCompetitors Promise.all", queriesErrors);
								reject(queriesErrors);
							});
					})
					.catch((getCompetitorsErrors) => {
						//console.log("refreshCompetitors getCompetitors", getCompetitorsErrors);
						reject(getCompetitorsErrors);
					});
			});
		},

		refreshDependentData() {
			return new Promise((resolve, reject) => {
				let baseQueries = [];
				baseQueries.push(this.refreshBrandsPages());
				baseQueries.push(this.refreshTopKeywords());
				baseQueries.push(this.refreshBrands());
				baseQueries.push(this.refreshCompetitors());
				Promise.all(baseQueries)
					.then(() => {
						this.refreshKeywordData(true).then(() => {
							resolve(true);
						});
					})
					.catch((queriesErrors) => {
						//console.log("refreshDependentData", queriesErrors);
						reject(queriesErrors);
					});
			});
		},

		refreshIndependentData() {
			return new Promise((resolve, reject) => {
				for (
					let i = 0;
					i < this.loadersIds.refreshIndependentData.noslug.length;
					i++
				) {
					if (
						this.loaderStatus[this.loadersIds.refreshIndependentData.noslug[i]]
							.length < 1 &&
						this.$refs &&
						this.$refs[this.loadersIds.refreshIndependentData.position[i]]
					) {
						// //console.log("Open", this.loadersIds.refreshIndependentData.data[i], " in ", this.loadersIds.refreshIndependentData.position[i])
						this.$refs[
							this.loadersIds.refreshIndependentData.position[i]
						].openLoadingContainer(
							this.loadersIds.refreshIndependentData.data[i]
						);
					}
					this.loaderStatus[
						this.loadersIds.refreshIndependentData.noslug[i]
					].push("refreshIndependentData");
				}
				let queries = [];
				queries.push(this.getConversionsOrRevenues());
				queries.push(this.getSocietyFavicon(this.selectedSociety.id));
				queries.push(this.getApiLastUpdate());
				Promise.all(queries)
					.then(() => {
						for (
							let i = 0;
							i < this.loadersIds.refreshIndependentData.noslug.length;
							i++
						) {
							this.loaderStatus[
								this.loadersIds.refreshIndependentData.noslug[i]
							] = this.loaderStatus[
								this.loadersIds.refreshIndependentData.noslug[i]
							].filter((row) => row != "refreshIndependentData");
							if (
								this.loaderStatus[
									this.loadersIds.refreshIndependentData.noslug[i]
								].length < 1 &&
								this.$refs &&
								this.$refs[this.loadersIds.refreshIndependentData.position[i]]
							) {
								// //console.log("Close", this.loadersIds.refreshIndependentData.data[i], " in ", this.loadersIds.refreshIndependentData.position[i])
								this.$refs[
									this.loadersIds.refreshIndependentData.position[i]
								].closeLoadingContainer(
									this.loadersIds.refreshIndependentData.data[i]
								);
							}
						}
						resolve(true);
					})
					.catch((queriesErrors) => {
						//console.log("refreshIndependentData", queriesErrors);
						reject(queriesErrors);
					});
			});
		},

		refreshAllData() {
			return new Promise((resolve, reject) => {
				// this.openLoading()
				let queries = [];
				this.refreshIndependentData();
				queries.push(this.refreshDependentData());
				Promise.all(queries)
					.then(() => {
						this.closeLoading();
						resolve(true);
					})
					.catch((queriesErrors) => {
						//console.log("refreshAllData", queriesErrors);
						reject(queriesErrors);
					});
			});
		},

		refreshGSCData() {
			return new Promise((resolve, reject) => {
				// this.openLoading()
				let queries = [];
				queries.push(this.refreshBrandsPages());
				queries.push(this.refreshKeywordData(true));
				Promise.all(queries)
					.then(() => {
						this.closeLoading();
						resolve(true);
					})
					.catch((queriesErrors) => {
						//console.log("refreshGSCData", queriesErrors);
						reject(queriesErrors);
					});
			});
		},

		// 0005 - Update
		saveAnalytics() {
			let societyObject = { ...this.selectedSociety };
			societyObject.analytics_id = this.modifiedAnalytics;
			let societyToUpdate = new Society(societyObject);
			societyToUpdate.update(this.selectedSociety.id, (err, result) => {
				if (err) {
					this.$vs.notify({
						title: "Erreur",
						text: "Une erreur s'est produite.",
					});
				}
				if (result) {
					// this.$store.commit("SET_SELECTED_SOCIETY", societyObject)
					this.selectedSociety.analytics_id = this.modifiedAnalytics;
					this.$vs.notify({
						title: "Succès",
						text: "Le client a bien été modifié.",
					});
					this.refreshIndependentData();
					this.showSocietyModificationAnalyticsPopupActive = false;
				}
			});
		},

		saveGsc() {
			let societyObject = { ...this.selectedSociety };
			societyObject.gsc_url = this.modifiedGSC;
			let societyToUpdate = new Society(societyObject);
			societyToUpdate.update(this.selectedSociety.id, (err, result) => {
				if (err) {
					this.$vs.notify({
						title: "Erreur",
						text: "Une erreur s'est produite.",
					});
				}
				if (result) {
					// this.$store.commit("SET_SELECTED_SOCIETY", societyObject)
					this.selectedSociety.gsc_url = this.modifiedGSC;
					this.$vs.notify({
						title: "Succès",
						text: "Le client a bien été modifié.",
					});
					this.refreshIndependentData();
					this.refreshGSCData();
					this.showSocietyModificationGscPopupActive = false;
				}
			});
		},

		setMaxRowMultiplicatorTKSERP(data) {
			this.maxRowMultiplicatorTKSERP = data;
		},

		setKeywordSearchInput(data) {
			this.keywordSearchInput = data;
		},

		updateNotification(success = false) {
			success
				? ""
				: this.$vs.notify({
						title: "Erreur",
						text: "Une erreur s'est produite.",
				  });
		},

		updateTopKeywordsTable(oldTopkeywords, newTopkeywords) {
			return new Promise((resolve) => {
				let newKeywords = [];
				let delKeywords = [];
				for (let i = 0; i < newTopkeywords.length; i++) {
					if (!oldTopkeywords.includes(newTopkeywords[i])) {
						newKeywords.push(newTopkeywords[i]);
					}
				}
				for (let i = 0; i < oldTopkeywords.length; i++) {
					if (!newTopkeywords.includes(oldTopkeywords[i])) {
						delKeywords.push(oldTopkeywords[i]);
					}
				}
				if (delKeywords.length > 0) {
					for (let i = 0; i < delKeywords.length; i++) {
						let serpComparisonKeys = Object.keys(
							this.topKeywordsSERPComparison.keywords
						);
						let serpComparisonIndex = serpComparisonKeys.indexOf(
							delKeywords[i]
						);
						if (serpComparisonIndex >= 0)
							delete this.topKeywordsSERPComparison.keywords[
								serpComparisonKeys[serpComparisonIndex]
							];

						let seoValueByKeywordIndex =
							this.topKeywordsSEOValueByKeyword.findIndex(
								(row) => row.keyword == delKeywords[i]
							);
						if (seoValueByKeywordIndex >= 0)
							this.topKeywordsSEOValueByKeyword.splice(
								seoValueByKeywordIndex,
								1
							);
					}
				}
				if (newKeywords.length > 0) {
					for (let i = 0; i < newKeywords.length; i++) {
						if (!this.topKeywordsSERPComparison.keywords[newKeywords[i]]) {
							this.topKeywordsSERPComparison.keywords[newKeywords[i]] = {};
						}
						for (
							let j = 0;
							j < this.topKeywordsSERPComparison.domains.length;
							j++
						) {
							this.topKeywordsSERPComparison.keywords[newKeywords[i]][
								this.topKeywordsSERPComparison.domains[j]
							] = Array(this.topKeywordsSERPComparison.dates.length).fill(-1);
						}

						if (!this.topKeywordsSERPComparison.keywords_info[newKeywords[i]]) {
							this.topKeywordsSERPComparison.keywords_info[newKeywords[i]] = {
								volume: 0,
								cpc: 0,
							};
						}

						let cpc = this.topKeywordsSERPComparison.keywords_info[
							newKeywords[i]
						]
							? this.topKeywordsSERPComparison.keywords_info[newKeywords[i]].cpc
							: 0;
						let volume = this.topKeywordsSERPComparison.keywords_info[
							newKeywords[i]
						]
							? this.topKeywordsSERPComparison.keywords_info[newKeywords[i]]
									.volume
							: 0;
						let kd = this.topKeywordsSERPComparison.keywords_info[
							newKeywords[i]
						]
							? this.topKeywordsSERPComparison.keywords_info[newKeywords[i]].kd
							: 0;
						this.topKeywordsSEOValueByKeyword.push({
							keyword: newKeywords[i],
							cpc: cpc,
							kd: kd,
							position: 101,
							volume: volume,
							value: 0,
						});
					}
				}
				resolve(true);
			});
		},

		updateTopKeywords(keywords) {
			return new Promise((resolve, reject) => {
				// this.openLoading()
				let oldTopKeywords = [...this.topKeywords];
				this.updateTopKeywordsTable(this.topKeywords, keywords.split(","));
				this.$http
					.post(this.apiUrl + "society/updateTopKeywords", {
						society_id: this.selectedSociety.id,
						keywords: keywords,
					})
					.then((result1) => {
						let queries = [];
						// queries.push(this.refreshCompetitors(true))
						queries.push(this.refreshTopKeywords(true));
						Promise.all(queries).then((refreshResult) => {
							this.topKeywords = result1.data;
							if (oldTopKeywords != result1.data)
								this.updateTopKeywordsTable(
									oldTopKeywords,
									keywords.split(",")
								);
							this.closeLoading();
							this.updateNotification(true);
							resolve(refreshResult);
						});
					})
					.catch((err) => {
						this.updateNotification(false);
						reject(err);
					});
			});
		},

		updateCompetitorsTable(oldCompetitors, newCompetitors) {
			return new Promise((resolve) => {
				let newComp = [];
				let delComp = [];
				for (let i = 0; i < newCompetitors.length; i++) {
					if (!oldCompetitors.includes(newCompetitors[i])) {
						newComp.push(newCompetitors[i]);
					}
				}
				for (let i = 0; i < oldCompetitors.length; i++) {
					if (!newCompetitors.includes(oldCompetitors[i])) {
						delComp.push(oldCompetitors[i]);
					}
				}
				if (delComp.length > 0) {
					for (let i = 0; i < delComp.length; i++) {
						// this.topKeywordsSEOValueOptions series[index]  xaxis.categories[index]
						let xaxisIndex =
							this.topKeywordsSEOValueOptions.xaxis.categories.indexOf(
								delComp[i]
							);
						if (xaxisIndex >= 0) {
							this.topKeywordsSEOValueOptions.xaxis.categories.splice(
								xaxisIndex,
								1
							);
							this.topKeywordsSEOValueOptions.series.splice(xaxisIndex, 1);
						}

						// this.topKeywordsSERPComparison keywords / domains
						let domainIndex = this.topKeywordsSERPComparison.domains.indexOf(
							delComp[i]
						);
						if (domainIndex >= 0) {
							for (let keyword of this.topKeywords) {
								if (
									this.topKeywordsSERPComparison.keywords[keyword] &&
									this.topKeywordsSERPComparison.keywords[keyword][
										this.topKeywordsSERPComparison.domains[domainIndex]
									]
								) {
									delete this.topKeywordsSERPComparison.keywords[keyword][
										this.topKeywordsSERPComparison.domains[domainIndex]
									];
								}
							}
							this.topKeywordsSERPComparison.domains.splice(domainIndex, 1);
						}
					}
				}
				if (newComp.length > 0) {
					for (let i = 0; i < newComp.length; i++) {
						// this.topKeywordsSEOValueOptions series[index]  xaxis.categories[index]
						this.topKeywordsSEOValueOptions.xaxis.categories.push(newComp[i]);
						this.topKeywordsSEOValueOptions.series.push(newComp[i]);
						// this.topKeywordsSERPComparison keywords / domains
						this.topKeywordsSERPComparison.domains.push(newComp[i]);
						for (let keyword of this.topKeywords) {
							if (this.topKeywordsSERPComparison.keywords[keyword]) {
								this.topKeywordsSERPComparison.keywords[keyword][newComp[i]] =
									Array(this.topKeywordsSERPComparison.dates.length).fill(-1);
							}
						}
					}
				}
				resolve(true);
			});
		},

		updateCompetitors(competitors) {
			return new Promise((resolve, reject) => {
				// this.openLoading()
				let oldCompetitors = [...this.competitors];
				this.$http
					.post(this.apiUrl + "society/updateCompetitors", {
						society_id: this.selectedSociety.id,
						competitors: competitors,
					})
					.then(() => {
						this.refreshCompetitors(true).then((refreshResult) => {
							this.updateCompetitorsTable(
								oldCompetitors,
								competitors.split(",")
							);
							this.competitors = competitors.split(",");
							this.closeLoading();
							this.updateNotification(true);
							resolve(refreshResult);
						});
					})
					.catch((err) => {
						this.updateNotification(false);
						reject(err);
					});
			});
		},

		updateBrands(updatedBrands) {
			return new Promise((resolve, reject) => {
				// this.openLoading()
				this.$http
					.post(this.apiUrl + "society/updateBrands", {
						society_id: this.selectedSociety.id,
						brands: updatedBrands,
					})
					.then((result) => {
						// FOR NEW BRANDS PUSH NEW REQUEST
						if (result.data != "") {
							let strToDateYear = this.toDate
								? this.toDate.substring(0, 4)
								: this.today.substring(0, 4);
							this.$http
								.get(
									`${this.apiUrl}society/getBrandsWithId/${this.selectedSociety.id}`
								)
								.then((selectResult) => {
									//////

									let keywords_batches = [];
									let result_to_slice_temp = [...selectResult.data];
									let result_to_slice = [];
									for (let keyword of result.data) {
										let found_brand_keyword = result_to_slice_temp.find(
											(row) => row.brand == keyword
										);
										if (found_brand_keyword) {
											result_to_slice.push(found_brand_keyword);
										}
									}

									if (result_to_slice.length > 25) {
										while (result_to_slice.length > 0) {
											if (result_to_slice.length > 20) {
												let keyword_batch = [];
												for (let i = 0; i < 20; i++) {
													let reqParamTemp = result_to_slice.pop();
													let reqParam = {
														year: strToDateYear,
														url: this.selectedSociety.gsc_url,
														keyword: reqParamTemp.brand,
														brand_id: reqParamTemp.id,
													};
													keyword_batch.push(reqParam);
												}
												keywords_batches.push(keyword_batch);
											} else {
												let keyword_batch = [];
												let resultLength = result_to_slice.length;
												for (let i = 0; i < resultLength; i++) {
													let reqParamTemp = result_to_slice.pop();
													let reqParam = {
														year: strToDateYear,
														url: this.selectedSociety.gsc_url,
														keyword: reqParamTemp.brand,
														brand_id: reqParamTemp.id,
													};
													keyword_batch.push(reqParam);
												}
												keywords_batches.push(keyword_batch);
											}
										}
									} else {
										let keyword_batch = [];
										for (let keyword of result_to_slice) {
											let reqParam = {
												year: strToDateYear,
												url: this.selectedSociety.gsc_url,
												keyword: keyword.brand,
												brand_id: keyword.id,
											};
											keyword_batch.push(reqParam);
										}
										keywords_batches.push(keyword_batch);
									}

									let paramBody = {
										keywords_batches: JSON.stringify(keywords_batches),
									};
									this.$http
										.post(
											this.apiUrl + "webmaster/newpagerankkwbatch",
											paramBody
										)
										.then(() => {
											this.brands = updatedBrands.split(",");
											let queries = [];
											queries.push(this.refreshBrandsPages());
											queries.push(this.refreshBrands(true));
											Promise.all(queries).then((queriesResults) => {
												this.updateNotification(true);
												this.closeLoading();
												resolve(queriesResults);
											});
										});
								});
						} else {
							this.brands = updatedBrands.split(",");
							let queries = [];
							queries.push(this.refreshBrandsPages());
							queries.push(this.refreshBrands(true));
							Promise.all(queries).then((queriesResults) => {
								this.updateNotification(true);
								this.closeLoading();
								resolve(queriesResults);
							});
						}
					})
					.catch((err) => {
						this.updateNotification(false);
						reject(err);
					});
			});
		},

		updateApiDate(apiLastUpdate = null) {
			if (apiLastUpdate) {
				this.apiLastUpdate = apiLastUpdate;
				let lastUpdate =
					apiLastUpdate.gsc < apiLastUpdate.ads
						? apiLastUpdate.ads
						: apiLastUpdate.gsc;
				lastUpdate =
					lastUpdate < apiLastUpdate.georanker
						? apiLastUpdate.georanker
						: lastUpdate;
				this.last_update = lastUpdate
					? lastUpdate
							.toISOString()
							.substring(0, 10)
							.split("-")
							.reverse()
							.join("/")
					: "";
			}
		},

		updateCompetitorsTableSort(keyTypeArray) {
			this.serpComparisonSortKey = keyTypeArray[0];
			this.serpComparisonSortType = keyTypeArray[1];
		},

		// 0006 - Build

		buildStackedColumnChartSeriesAndXaxis(strFromDate, strToDate) {
			let max_yaxis = 1;
			let xaxis = [];
			let series = [
				{
					name: "Total",
					type: "line",
					data: [],
				},
				{
					name: "51-100",
					type: "column",
					data: [],
				},
				{
					name: "21-50",
					type: "column",
					data: [],
				},
				{
					name: "11-20",
					type: "column",
					data: [],
				},
				{
					name: "4-10",
					type: "column",
					data: [],
				},
				{
					name: "Top 3",
					type: "column",
					data: [],
				},
			];

			// Merge Gsc and Georanker data
			let fromDate = new Date(strFromDate);
			let toDate = new Date(strToDate);
			let startMonth = fromDate.getMonth();
			let startYear = fromDate.getFullYear();
			while (startYear <= toDate.getFullYear()) {
				if (startYear < toDate.getFullYear()) {
					while (startMonth <= 11) {
						if (startMonth + 1 < 10) {
							xaxis.push(`${startYear}-0${startMonth + 1}-01`);
						} else {
							xaxis.push(`${startYear}-${startMonth + 1}-01`);
						}
						startMonth = startMonth + 1;
					}
				} else {
					while (startMonth <= toDate.getMonth()) {
						if (startMonth + 1 < 10) {
							xaxis.push(`${startYear}-0${startMonth + 1}-01`);
						} else {
							xaxis.push(`${startYear}-${startMonth + 1}-01`);
						}
						startMonth = startMonth + 1;
					}
				}

				startMonth = 0;
				startYear = startYear + 1;
			}
			// Initialize each data array with 0
			for (let i = 0; i < xaxis.length; i++) {
				series.forEach((serie) => {
					serie.data.push(0);
				});
			}

			// Set value for each data according to dates and rank tier (with findIndex)
			for (let index = 0; index < xaxis.length; index++) {
				/*
				 * let year = date.substring(0,4)
				 * let month = parseInt(date.substring(5,7)) - 1
				 * COMPARE DATE OF data TO PUT IT INTO index
				 */
				for (let keyword in this.topKeywordsSERPComparison.keywords) {
					let data =
						this.topKeywordsSERPComparison &&
						this.topKeywordsSERPComparison.keywords[keyword] &&
						this.topKeywordsSERPComparison.keywords[keyword][
							this.topKeywordsSERPComparison.domains[0]
						] &&
						this.topKeywordsSERPComparison.keywords[keyword][
							this.topKeywordsSERPComparison.domains[0]
						][index]
							? this.topKeywordsSERPComparison.keywords[keyword][
									this.topKeywordsSERPComparison.domains[0]
							  ][index]
							: null;
					if (data != null) {
						if (data > 0 && data < 4) {
							series[5].data[index] = series[5].data[index] + 1;
							series[0].data[index] = series[0].data[index] + 1;
						} else if (data > 3 && data < 11) {
							series[4].data[index] = series[4].data[index] + 1;
							series[0].data[index] = series[0].data[index] + 1;
						} else if (data > 10 && data < 21) {
							series[3].data[index] = series[3].data[index] + 1;
							series[0].data[index] = series[0].data[index] + 1;
						} else if (data > 20 && data < 51) {
							series[2].data[index] = series[2].data[index] + 1;
							series[0].data[index] = series[0].data[index] + 1;
						} else if (data > 50 && data < 100) {
							series[1].data[index] = series[1].data[index] + 1;
							series[0].data[index] = series[0].data[index] + 1;
						}
					}
				}
			}

			let keywordNumberEvolutionValue = parseInt(
				series[0].data[xaxis.length - 1] - series[0].data[xaxis.length - 2]
			);
			this.keywordNumberEvolution.value = this.formatThousandNumb(
				keywordNumberEvolutionValue
			);
			this.keywordNumberEvolution.statistics =
				series[0].data[xaxis.length - 1] > 0
					? this.formatThousandNumb(series[0].data[xaxis.length - 1])
					: 0;
			if (keywordNumberEvolutionValue == 0) {
				this.keywordNumberEvolution.color = "grey";
				this.keywordNumberEvolution.icon = "";
				this.keywordNumberEvolution.itext = "=";
			} else if (keywordNumberEvolutionValue > 0) {
				this.keywordNumberEvolution.color = "success";
				this.keywordNumberEvolution.icon = "icon-arrow-up-right";
			} else {
				this.keywordNumberEvolution.color = "danger";
				this.keywordNumberEvolution.icon = "icon-arrow-down-right";
			}

			for (let value of series[0].data) {
				max_yaxis = value > max_yaxis ? value : max_yaxis;
			}
			return [xaxis, series, max_yaxis];
		},

		buildStackedColumnChartSeriesAndXaxisKeywords(strFromDate, strToDate) {
			let max_yaxis = 1;
			console.time("buildStackedColumnChartSeriesAndXaxisKeywords");
			let xaxis = [];
			let series = [
				{
					name: "Total",
					type: "line",
					data: [],
				},
				{
					name: "51-100",
					type: "column",
					data: [],
				},
				{
					name: "21-50",
					type: "column",
					data: [],
				},
				{
					name: "11-20",
					type: "column",
					data: [],
				},
				{
					name: "4-10",
					type: "column",
					data: [],
				},
				{
					name: "Top 3",
					type: "column",
					data: [],
				},
			];

			// Merge Gsc and Georanker data
			let fromDate = new Date(strFromDate);
			let toDate = new Date(strToDate);
			let startMonth = fromDate.getMonth();
			let startYear = fromDate.getFullYear();
			while (startYear <= toDate.getFullYear()) {
				if (startYear < toDate.getFullYear()) {
					while (startMonth <= 11) {
						if (startMonth + 1 < 10) {
							xaxis.push(`${startYear}-0${startMonth + 1}-01`);
						} else {
							xaxis.push(`${startYear}-${startMonth + 1}-01`);
						}
						startMonth = startMonth + 1;
					}
				} else {
					while (startMonth <= toDate.getMonth()) {
						if (startMonth + 1 < 10) {
							xaxis.push(`${startYear}-0${startMonth + 1}-01`);
						} else {
							xaxis.push(`${startYear}-${startMonth + 1}-01`);
						}
						startMonth = startMonth + 1;
					}
				}

				startMonth = 0;
				startYear = startYear + 1;
			}
			// Initialize each data array with 0
			for (let i = 0; i < xaxis.length; i++) {
				series.forEach((serie) => {
					serie.data.push(0);
				});
			}

			// Set value for each data according to dates and rank tier (with findIndex)
			let index = 0;
			for (let date of xaxis) {
				let year = date.substring(0, 4);
				let month = parseInt(date.substring(5, 7)) - 1;
				if (
					this.keywordData &&
					this.keywordData[year] &&
					this.keywordData[year][month]
				) {
					for (let keyword of this.keywordData[year][month]) {
						let data = keyword ? keyword : null;
						if (data != null) {
							if (data.position <= 0) {
								continue;
							} else if (data.position > 0 && data.position < 4) {
								series[5].data[index] = series[5].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							} else if (data.position < 11) {
								series[4].data[index] = series[4].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							} else if (data.position < 21) {
								series[3].data[index] = series[3].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							} else if (data.position < 51) {
								series[2].data[index] = series[2].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							} else if (data.position < 100) {
								series[1].data[index] = series[1].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							}
						}
					}
				}
				index = index + 1;
			}
			for (let value of series[0].data) {
				max_yaxis = value > max_yaxis ? value : max_yaxis;
			}
			console.timeEnd("buildStackedColumnChartSeriesAndXaxisKeywords");
			return [xaxis, series, max_yaxis];
		},

		buildStackedColumnChartOptionBrandTrafficSeriesAndXaxis() {
			return new Promise((resolve) => {
				let xaxis = this.makeDateXaxis();
				let series = [
					{
						data: Array(xaxis.length).fill(0),
						name: "Clics",
						type: "column",
					},
					{
						data: Array(xaxis.length).fill(0),
						name: "Impressions",
						type: "column",
					},
				];
				let max = 0;
				if (this.brandData) {
					let keywordsKeys = Object.keys(this.brandData);
					for (let keyword of keywordsKeys) {
						let yearKeys = Object.keys(this.brandData[keyword]);
						for (let yearKey of yearKeys) {
							if (this.brandData[keyword][yearKey]) {
								for (let monthKey in this.brandData[keyword][yearKey]) {
									if (this.brandData[keyword][yearKey][monthKey]) {
										let foundIndex = xaxis.findIndex(
											(row) =>
												row.substring(0, 4) == yearKey &&
												parseInt(monthKey) + 1 == row.substring(5, 7)
										);
										if (foundIndex >= 0) {
											for (let brandKeyword of this.brandData[keyword][yearKey][
												monthKey
											]) {
												series[0].data[foundIndex] += brandKeyword.clicks;
												series[1].data[foundIndex] += brandKeyword.impressions;
											}
										}
									}
								}
							}
						}
					}

					for (let i = 0; i < xaxis.length; i++) {
						max =
							max < series[0].data[i] + series[1].data[i]
								? series[0].data[i] + series[1].data[i]
								: max;
					}
				}
				resolve([xaxis, series, max]);
			});
		},

		buildStackedColumnChartSeriesAndXaxisCompetitorComparison() {
			//console.log("buildStackedColumnChartSeriesAndXaxisCompetitorComparison BEGIN");
			let max_yaxis = 1;
			let xaxis = [this.selectedSociety.name, ...this.competitors];
			let series = [
				{
					name: "Total",
					type: "line",
					data: [],
				},
				{
					name: "51-100",
					type: "column",
					data: [],
				},
				{
					name: "21-50",
					type: "column",
					data: [],
				},
				{
					name: "11-20",
					type: "column",
					data: [],
				},
				{
					name: "4-10",
					type: "column",
					data: [],
				},
				{
					name: "Top 3",
					type: "column",
					data: [],
				},
			];

			let dates = this.makeDateXaxis();
			let selectedDate = "";

			// xaxis.push(this.selectedSociety.name) // SOCIETY

			/*
			 * for(let i = 0; i < this.competitors.length; i++){
			 *   xaxis.push(this.competitors[i])
			 * }
			 */

			// //console.log("Serie Before Array Fill:", JSON.stringify(series))

			// for(let i = 0; i < xaxis.length; i++){
			for (let i = 0; i < series.length; i++) {
				for (let j = 0; j < xaxis.length; j++) {
					series[i].data.push(0);
				}
			}
			/*
			 * series.forEach(serie => {
			 *   serie.data = Array(xaxis.length).fill(0)
			 * })
			 * }
			 * //console.log("Xaxis", xaxis)
			 * //console.log("Serie Before Society:", JSON.stringify(series))
			 * Set society value
			 */
			let subMonthValue = 0;
			let continueProcess = true;
			/*
			 * //console.log("series[0].data[0]", series[0].data[0])
			 * //console.log("WHILE BEGIN", series[0].data[0])
			 */

			while (continueProcess && series[0].data[0] <= 0) {
				subMonthValue += 1;
				// //console.log("topKeywordsSERPComparison.keywords.length", Object.keys(this.topKeywordsSERPComparison.keywords))
				let tkSERPCompKeys = Object.keys(
					this.topKeywordsSERPComparison.keywords
				);
				if (tkSERPCompKeys.length <= 0) {
					//console.log("continueProcess while false");
					continueProcess = false;
					break;
				}
				for (let keyword in this.topKeywordsSERPComparison.keywords) {
					if (
						!this.topKeywordsSERPComparison.keywords ||
						!this.topKeywordsSERPComparison.keywords[keyword] ||
						!this.topKeywordsSERPComparison.keywords[keyword][
							this.topKeywordsSERPComparison.domains[0]
						]
					) {
						continue;
					}
					let lastMonth =
						this.topKeywordsSERPComparison.keywords[keyword][
							this.topKeywordsSERPComparison.domains[0]
						].length - subMonthValue;
					selectedDate = dates[lastMonth];
					// //console.log(lastMonth, selectedDate)
					if (lastMonth < 0) {
						//console.log("continueProcess if false");
						continueProcess = false;
						break;
					}
					let data =
						this.topKeywordsSERPComparison &&
						this.topKeywordsSERPComparison.keywords[keyword] &&
						this.topKeywordsSERPComparison.keywords[keyword][
							this.topKeywordsSERPComparison.domains[0]
						] &&
						this.topKeywordsSERPComparison.keywords[keyword][
							this.topKeywordsSERPComparison.domains[0]
						][lastMonth]
							? this.topKeywordsSERPComparison.keywords[keyword][
									this.topKeywordsSERPComparison.domains[0]
							  ][lastMonth]
							: null;
					if (data != null) {
						if (data > 0 && data < 4) {
							series[5].data[0] = series[5].data[0] + 1;
							series[0].data[0] = series[0].data[0] + 1;
						} else if (data > 3 && data < 11) {
							series[4].data[0] = series[4].data[0] + 1;
							series[0].data[0] = series[0].data[0] + 1;
						} else if (data > 10 && data < 21) {
							series[3].data[0] = series[3].data[0] + 1;
							series[0].data[0] = series[0].data[0] + 1;
						} else if (data > 20 && data < 51) {
							series[2].data[0] = series[2].data[0] + 1;
							series[0].data[0] = series[0].data[0] + 1;
						} else if (data > 50 && data < 100) {
							series[1].data[0] = series[1].data[0] + 1;
							series[0].data[0] = series[0].data[0] + 1;
						}
					}
				}
				// if(lastMonth < 0) continueProcess = false
			}
			/*
			 * //console.log("WHILE END")
			 * //console.log("Serie After Society:", JSON.stringify(series))
			 * Set value for each data according to dates and rank tier (with findIndex)
			 */
			let index = 1;
			//console.log("Competitors continueProcess", continueProcess);
			if (continueProcess) {
				for (
					let competitorIndex = 1;
					competitorIndex < xaxis.length;
					competitorIndex++
				) {
					// COMPARE DATE OF data TO PUT IT INTO index
					for (let keyword in this.topKeywordsSERPComparison.keywords) {
						if (
							!this.topKeywordsSERPComparison.keywords ||
							!this.topKeywordsSERPComparison.keywords[keyword] ||
							!this.topKeywordsSERPComparison.keywords[keyword][
								this.topKeywordsSERPComparison.domains[0]
							]
						) {
							continueProcess = false;
							break;
						}
						let lastMonth =
							this.topKeywordsSERPComparison.keywords[keyword][
								this.topKeywordsSERPComparison.domains[0]
							].length - subMonthValue;
						let data =
							this.topKeywordsSERPComparison &&
							this.topKeywordsSERPComparison.keywords[keyword] &&
							this.topKeywordsSERPComparison.keywords[keyword][
								xaxis[competitorIndex]
							] &&
							this.topKeywordsSERPComparison.keywords[keyword][
								xaxis[competitorIndex]
							][lastMonth]
								? this.topKeywordsSERPComparison.keywords[keyword][
										xaxis[competitorIndex]
								  ][lastMonth]
								: null;
						if (data != null) {
							if (data > 0 && data < 4) {
								series[5].data[index] = series[5].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							} else if (data > 3 && data < 11) {
								series[4].data[index] = series[4].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							} else if (data > 10 && data < 21) {
								series[3].data[index] = series[3].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							} else if (data > 20 && data < 51) {
								series[2].data[index] = series[2].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							} else if (data > 50 && data < 100) {
								series[1].data[index] = series[1].data[index] + 1;
								series[0].data[index] = series[0].data[index] + 1;
							}
						}
					}

					index = index + 1;
				}
			}
			// //console.log("Serie After Competitors:", series)

			for (let value of series[0].data) {
				max_yaxis = value > max_yaxis ? value : max_yaxis;
			}
			selectedDate = selectedDate
				? selectedDate.split("-").reverse().join("/")
				: "";
			// //console.log("buildStackedColumnChartSeriesAndXaxisCompetitorComparison RETURN")
			return [
				[this.selectedSociety.name, ...this.competitorsName],
				series,
				max_yaxis,
				selectedDate,
			];
		},

		buildTopKeywordsHistDataSeriesAndXaxis() {
			return new Promise((resolve, reject) => {
				console.time("buildTopKeywordsHistDataSeriesAndXaxis");
				let xaxis = [];
				let favicons = [];
				// Ajouter la notion de concurrent
				xaxis.push(this.getUrlDomain(this.selectedSociety.gsc_url));
				favicons.push("");
				let series = [];
				// let seoValue = 0

				// let today = new Date(Date.now())
				let today = new Date(this.statDateFilter.toDate);

				let year = today.getFullYear();
				let month = today.getMonth() + 1;
				if (month < 1) {
					month = 12;
					year = parseInt(year) - 1;
					year = year.toString();
				}

				this.getSeoValueByKeywordsForSociety(year, month, true).then(
					async (response) => {
						//console.log("SEO Value response: ", response);
						let thisMonthSeoValue = Math.round(response);
						//console.log("thisMonthSeoValue: ", thisMonthSeoValue);
						let substractMonthValue = this.seoValueByKeywordPreviousMonthWarning
							? 2
							: 1;
						let previousMonth = month - substractMonthValue;
						let previousYear = year;
						if (previousMonth < 1) {
							previousMonth = 12 - previousMonth;
							previousYear = parseInt(previousYear) - 1;
							previousYear = previousYear.toString();
						}
						let lastMonthSeoValue = await this.getSeoValueByKeywordsForSociety(
							previousYear,
							previousMonth,
							false
						);
						//////
						lastMonthSeoValue = Math.round(lastMonthSeoValue);

						console.timeEnd(
							"buildTopKeywordsHistDataSeriesAndXaxis getSeoValueByKeywordsForSociety 2"
						);
						this.seoValueEvolution.statistics =
							thisMonthSeoValue > 0
								? this.formatThousandNumb(thisMonthSeoValue)
								: 0;
						this.seoValueEvolution.value = Math.round(
							thisMonthSeoValue - lastMonthSeoValue
						);
						if (this.seoValueEvolution.value < 0) {
							this.seoValueEvolution.icon = "icon-arrow-down-right";
							this.seoValueEvolution.color = "danger";
						} else if (this.seoValueEvolution.value > 0) {
							this.seoValueEvolution.icon = "icon-arrow-up-right";
							this.seoValueEvolution.color = "success";
						} else {
							this.seoValueEvolution.itext = "=";
							this.seoValueEvolution.color = "grey";
						}
						this.seoValueEvolution.value = this.formatThousandNumb(
							this.seoValueEvolution.value
						);
						console.time(
							"buildTopKeywordsHistDataSeriesAndXaxis sort topKeywordsSEOValueByKeyword"
						);
						this.topKeywordsSEOValueByKeyword.sort((a, b) => {
							// Use toUpperCase() to ignore character casing
							const keywordA = a.value;
							const keywordB = b.value;

							let comparison = 0;
							if (keywordA < keywordB) {
								comparison = 1;
							} else if (keywordA > keywordB) {
								comparison = -1;
							}
							return comparison;
						});
						console.timeEnd(
							"buildTopKeywordsHistDataSeriesAndXaxis sort topKeywordsSEOValueByKeyword"
						);
						series.push(thisMonthSeoValue);

						console.time("buildTopKeywordsHistDataSeriesAndXaxis competitors");
						let globalYear = this.seoValueByKeywordPreviousMonthWarning
							? previousYear
							: year;
						let globalMonth = this.seoValueByKeywordPreviousMonthWarning
							? previousMonth
							: month;
						this.getGlobalSeoValuesForSociety(globalYear, globalMonth)
							.then((result) => {
								for (let i = 0; i < this.competitors.length; i++) {
									favicons.push(this.getFaviconSource(this.competitors[i]));
									let competitorId = this.competitorsId[i];
									let foundCompetitor = result.find(
										(competitor) => competitor.id == competitorId
									);

									let competitorValue = foundCompetitor
										? foundCompetitor.sum_value
										: 0;
									xaxis.push(this.competitors[i]);
									series.push(competitorValue);
								}
								console.timeEnd(
									"buildTopKeywordsHistDataSeriesAndXaxis competitors"
								);
								console.timeEnd("buildTopKeywordsHistDataSeriesAndXaxis");
								// seoValue * pourcentage_position <------------
								resolve([xaxis, series, favicons]);
							})
							.catch((err) => {
								reject(err);
							});
					}
				);

				// })
			});
		},

		buildTopKeywordsSERPComparison(completeRefresh = false) {
			return new Promise((resolve, reject) => {
				console.time("buildTopKeywordsSERPComparison");
				let society_domain = this.getUrlDomain(this.selectedSociety.gsc_url);

				let topKeywordsSERPComparison = {
					dates: [],
					keywords: {},
					keywords_info: {},
					domains: [],
				};

				topKeywordsSERPComparison.domains.push(society_domain);
				console.time("for-competitor");
				for (let competitor of this.competitors) {
					topKeywordsSERPComparison.domains.push(competitor);
				}
				console.timeEnd("for-competitor");

				let fromDate = new Date(this.fromDate);
				let toDate = new Date(this.toDate);
				let startMonth = fromDate.getMonth();
				let startYear = fromDate.getFullYear();
				console.time("while-from-to");
				while (startYear <= toDate.getFullYear()) {
					if (startYear < toDate.getFullYear()) {
						while (startMonth <= 11) {
							if (startMonth + 1 < 10) {
								topKeywordsSERPComparison.dates.push(
									`${startYear}-0${startMonth + 1}`
								);
							} else {
								topKeywordsSERPComparison.dates.push(
									`${startYear}-${startMonth + 1}`
								);
							}
							startMonth = startMonth + 1;
						}
					} else {
						while (startMonth <= toDate.getMonth()) {
							if (startMonth + 1 < 10) {
								topKeywordsSERPComparison.dates.push(
									`${startYear}-0${startMonth + 1}`
								);
							} else {
								topKeywordsSERPComparison.dates.push(
									`${startYear}-${startMonth + 1}`
								);
							}
							startMonth = startMonth + 1;
						}
					}

					startMonth = 0;
					startYear = startYear + 1;
				}

				console.timeEnd("while-from-to");
				console.time("getserpsocieties");
				this.$http
					.get(
						this.apiUrl +
							"georanker/getserpsocieties/" +
							this.selectedSociety.id +
							"/" +
							topKeywordsSERPComparison.dates[0] +
							"/" +
							topKeywordsSERPComparison.dates[
								topKeywordsSERPComparison.dates.length - 1
							]
					)
					.then((result) => {
						console.timeEnd("getserpsocieties");
						// //console.log("getserpsocieties result.data: ", result.data);
						let serpData = result.data;
						let topkeywordsCounter = [...this.topKeywords];
						let currKeyword = null;
						let societyName = null;
						console.time("for-serpdata");
						for (let i = 0; i < serpData.length; i++) {
							if (
								currKeyword != serpData[i].keyword ||
								societyName != serpData[i].url
							) {
								currKeyword = serpData[i].keyword;
								// //console.log("currKeyword Change:", currKeyword);
								let topkeywordsCounterIndex =
									topkeywordsCounter.includes(currKeyword);
								if (topkeywordsCounterIndex >= 0)
									topkeywordsCounter.splice(topkeywordsCounter, 1);
								societyName = serpData[i].url;
								if (!topKeywordsSERPComparison.keywords[currKeyword]) {
									topKeywordsSERPComparison.keywords[currKeyword] = {};
									topKeywordsSERPComparison.keywords[currKeyword][societyName] =
										Array(topKeywordsSERPComparison.dates.length).fill(-1);
								}
								for (let x = serpData.length - 1; x >= 0; x--) {
									if (serpData[x].keyword == currKeyword) {
										topKeywordsSERPComparison.keywords_info[currKeyword] = {
											volume: parseInt(serpData[x].volume),
											cpc: serpData[x].cpc,
											kd: serpData[x].kd,
										};
										break;
									}
								}
							}
							let foundDate = topKeywordsSERPComparison.dates.indexOf(
								serpData[i].date
							);

							if (foundDate >= 0) {
								// //console.log("currKeyword foundDate:", currKeyword, serpData[i].date, societyName, foundDate, serpData[i].position);
								topKeywordsSERPComparison.keywords[currKeyword][societyName][
									foundDate
								] = serpData[i].position;
								// if(serpData[i].position > 0) //console.log(`currKeyword position: ${currKeyword}`, societyName, JSON.stringify(topKeywordsSERPComparison.keywords[currKeyword][societyName]));
							}
						}
						// //console.log("topKeywordsSERPComparison.keywords[currKeyword][societyName][foundDate]", JSON.stringify(topKeywordsSERPComparison.keywords));
						console.timeEnd("for-serpdata");
						if (topkeywordsCounter.length > 0) {
							console.time("for-topkeywordcounter");
							for (let i = 0; i < topkeywordsCounter.length; i++) {
								if (
									!topKeywordsSERPComparison.keywords[topkeywordsCounter[i]]
								) {
									topKeywordsSERPComparison.keywords[topkeywordsCounter[i]] =
										{};
								}
								topKeywordsSERPComparison.keywords[topkeywordsCounter[i]][
									topKeywordsSERPComparison.domains[0]
								] = Array(topKeywordsSERPComparison.dates.length).fill(-1);
								if (
									!topKeywordsSERPComparison.keywords_info[
										topkeywordsCounter[i]
									]
								) {
									topKeywordsSERPComparison.keywords_info[
										topkeywordsCounter[i]
									] = { volume: 0, cpc: 0, kd: 0 };
								}
							}
							console.timeEnd("for-topkeywordcounter");
						}
						console.time("getserpcompetitors");

						this.$http
							.get(
								this.apiUrl +
									"georanker/getserpcompetitors/" +
									this.selectedSociety.id +
									"/" +
									topKeywordsSERPComparison.dates[0] +
									"/" +
									topKeywordsSERPComparison.dates[
										topKeywordsSERPComparison.dates.length - 1
									]
							)
							.then((resultCompetitor) => {
								console.timeEnd("getserpcompetitors");
								let serpCompetitorData = resultCompetitor.data;
								topkeywordsCounter = [...this.topKeywords];
								currKeyword = null;
								let competitorName = null;
								console.time("for-serpcompetitordata");
								for (let i = 0; i < serpCompetitorData.length; i++) {
									if (
										currKeyword != serpCompetitorData[i].keyword ||
										competitorName != serpCompetitorData[i].url
									) {
										currKeyword = serpCompetitorData[i].keyword;
										let topkeywordsCounterIndex =
											topkeywordsCounter.includes(currKeyword);
										if (topkeywordsCounterIndex >= 0)
											topkeywordsCounter.splice(topkeywordsCounter, 1);
										competitorName = serpCompetitorData[i].url;
										if (!topKeywordsSERPComparison.keywords[currKeyword]) {
											topKeywordsSERPComparison.keywords[currKeyword] = {};
										}
										if (
											!topKeywordsSERPComparison.keywords[currKeyword][
												competitorName
											]
										) {
											topKeywordsSERPComparison.keywords[currKeyword][
												competitorName
											] = Array(topKeywordsSERPComparison.dates.length).fill(
												-1
											);
										}
									}
									let foundDate = topKeywordsSERPComparison.dates.indexOf(
										serpCompetitorData[i].date
									);
									if (foundDate >= 0) {
										topKeywordsSERPComparison.keywords[currKeyword][
											competitorName
										][foundDate] = serpCompetitorData[i].position;
									}
								}
								console.timeEnd("for-serpcompetitordata");
								if (
									topkeywordsCounter.length > 0 &&
									topKeywordsSERPComparison.domains.length > 1
								) {
									console.time("for-topkeywordcounter-competitor");
									for (let i = 0; i < topkeywordsCounter.length; i++) {
										for (
											let j = 1;
											j < topKeywordsSERPComparison.domains.length;
											j++
										) {
											if (
												!topKeywordsSERPComparison.keywords[
													topkeywordsCounter[i]
												]
											) {
												topKeywordsSERPComparison.keywords[
													topkeywordsCounter[i]
												] = {};
											}
											if (
												!topKeywordsSERPComparison.keywords[
													topkeywordsCounter[i]
												][topKeywordsSERPComparison.domains[j]]
											) {
												topKeywordsSERPComparison.keywords[
													topkeywordsCounter[i]
												][topKeywordsSERPComparison.domains[j]] = Array(
													topKeywordsSERPComparison.dates.length
												).fill(-1);
											}
											if (
												!topKeywordsSERPComparison.keywords_info[
													topkeywordsCounter[i]
												]
											) {
												topKeywordsSERPComparison.keywords_info[
													topkeywordsCounter[i]
												] = { volume: 0, cpc: 0, kd: 0 };
											}
										}
									}
									console.timeEnd("for-topkeywordcounter-competitor");
								}

								this.topKeywordsSERPComparison = topKeywordsSERPComparison;
								let queries = [];
								queries.push(this.setStackedBarChartOptionsTopKeywords());
								// queries.push(this.setStackedBarChartOptionsTopKeywordsCompetitorsComparison()); // OPTIONNAL

								if (completeRefresh) {
									queries.push(this.setTopKeywordsHistDataOptions());
								}
								console.time("promise-all");
								Promise.all(queries)
									.then(() => {
										console.timeEnd("promise-all");
										console.timeEnd("buildTopKeywordsSERPComparison");
										resolve(topKeywordsSERPComparison);
									})
									.catch((queriesErrors) => {
										console.timeEnd("promise-all");
										//console.log("buildTopKeywordsSERPComparison", queriesErrors);
										reject(queriesErrors);
									});
							})
							.catch((error) => {
								//console.log("georanker/getserpcompetitors", error);
								reject(error);
							});
					})
					.catch((error) => {
						//console.log("georanker/getserpcompetitors", error);
						reject(error);
					});
			});
		},

		// 0007 - Set
		setStackedBarChartOptionsTopKeywords() {
			return new Promise((resolve) => {
				console.time("setStackedBarChartOptionsTopKeywords");

				// MAKE COPY OF DEFAULT OPTIONS
				let stackedColumnChartOptionTopKeywords = {
					series: [],
					chartOptions: {
						chart: {
							type: "bar",
							height: 350,
							stacked: true,
							toolbar: {
								show: false,
							},
							zoom: {
								enabled: false,
							},
							events: {
								click: (event, chartContext, config) => {
									this.displayTopKeywordListPopup(
										config.config.xaxis.categories[
											config.dataPointIndex
										].substring(3, 7),
										config.config.xaxis.categories[
											config.dataPointIndex
										].substring(0, 2)
									);
								},
							},
						},
						dataLabels: {
							enabled: true,
							enabledOnSeries: true,
							formatter: function (val) {
								return val;
							},
							textAnchor: "middle",
							distributed: false,
							offsetX: 0,
							offsetY: -5,
							style: {
								colors: ["#000", "#FFF", "#FFF", "#FFF", "#FFF", "#FFF"],
							},
						},
						plotOptions: {
							bar: {
								borderRadius: 8,
								horizontal: false,
							},
						},
						xaxis: {
							categories: [],
						},
						yaxis: {
							max: 1,
							title: {
								text: "Nombre de Top Keywords",
								rotate: 270,
								offsetX: 0,
								offsetY: 0,
							},
						},
						tooltip: {
							shared: true,
							intersect: false,
							inverseOrder: true,
						},
						legend: {
							position: "bottom",
							onItemClick: {
								toggleDataSeries: false,
							},
							offsetY: 5,
							inverseOrder: true,
						},
						fill: {
							opacity: 1,
						},
						colors: this.colorsStack,
					},
				};

				// SET SERIES
				let [xaxis, series, max] = this.buildStackedColumnChartSeriesAndXaxis(
					this.fromDate,
					this.toDate
				);

				stackedColumnChartOptionTopKeywords.chartOptions.xaxis.categories =
					xaxis
						? xaxis.map((xdate) =>
								xdate.substring(0, 7).split("-").reverse().join("/")
						  )
						: [];
				let today = new Date(Date.now());
				if (
					stackedColumnChartOptionTopKeywords.chartOptions.xaxis.categories
						.length > 0 &&
					today.getFullYear() ==
						parseInt(
							stackedColumnChartOptionTopKeywords.chartOptions.xaxis.categories[
								stackedColumnChartOptionTopKeywords.chartOptions.xaxis
									.categories.length - 1
							].substring(3, 7)
						) &&
					today.getMonth() ==
						parseInt(
							stackedColumnChartOptionTopKeywords.chartOptions.xaxis.categories[
								stackedColumnChartOptionTopKeywords.chartOptions.xaxis
									.categories.length - 1
							].substring(0, 2)
						) -
							1
				) {
					stackedColumnChartOptionTopKeywords.chartOptions.xaxis.categories[
						stackedColumnChartOptionTopKeywords.chartOptions.xaxis.categories
							.length - 1
					] =
						stackedColumnChartOptionTopKeywords.chartOptions.xaxis.categories[
							stackedColumnChartOptionTopKeywords.chartOptions.xaxis.categories
								.length - 1
						] + " (en cours)";
				}
				stackedColumnChartOptionTopKeywords.series = series;
				stackedColumnChartOptionTopKeywords.chartOptions.yaxis.max = max;

				this.stackedColumnChartOptionTopKeywords =
					stackedColumnChartOptionTopKeywords;
				this.setPerfDataChart().then(() => {
					resolve(true);
				});
				console.timeEnd("setStackedBarChartOptionsTopKeywords");
			});
		},

		setStackedBarChartOptionsBrandTraffic() {
			return new Promise((resolve) => {
				console.time("setStackedBarChartOptionsBrandTraffic");

				// MAKE COPY OF DEFAULT OPTIONS
				let stackedColumnChartOptionBrandTraffic = {
					series: [],
					chartOptions: {
						chart: {
							type: "line",
							height: 350,
							toolbar: {
								show: false,
							},
							zoom: {
								enabled: false,
							},
							/*
							 * events: {
							 *   click: (event, chartContext, config) => {
							 *     this.displayTopKeywordListPopup(config.config.xaxis.categories[config.dataPointIndex].substring(3,7), config.config.xaxis.categories[config.dataPointIndex].substring(0,2))
							 *   }
							 * }
							 */
						},
						/*
						 * dataLabels: {
						 *   enabled: true,
						 *   enabledOnSeries: true,
						 *   formatter: function (val) {
						 *       return val
						 *   },
						 *   textAnchor: 'middle',
						 *   distributed: false,
						 *   style: {
						 *       colors: [this.colorsStack[4],this.colorsStack[1]]
						 *   },
						 * },
						 * plotOptions: {
						 *   bar: {
						 *     borderRadius: 8,
						 *     horizontal: false,
						 *   },
						 * },
						 */
						markers: {
							size: 5,
							shape: "circle",
							radius: 2,
							hover: {
								size: 5,
							},
						},
						xaxis: {
							categories: [],
						},
						yaxis: {
							max: 1,
							title: {
								text: "Clics & Impressions",
								rotate: 270,
								offsetX: 0,
								offsetY: 0,
							},
						},
						/*
						 * tooltip: {
						 *   shared: true,
						 *   intersect: false,
						 *   inverseOrder: true,
						 * },
						 */
						legend: {
							position: "bottom",
							onItemClick: {
								toggleDataSeries: false,
							},
							offsetY: 5,
							inverseOrder: true,
						},
						fill: {
							opacity: 1,
						},
						colors: [this.colorsStack[4], this.colorsStack[1]],
					},
				};

				/*
				 * SET SERIES
				 * this.buildStackedColumnChartOptionBrandTrafficSeriesAndXaxis()
				 * .then(([xaxis, series, max]) => {
				 */
				let xaxis = this.stackedColumnChartOptionBrandTrafficSeriesAndXaxis
					? this.stackedColumnChartOptionBrandTrafficSeriesAndXaxis.xaxis
					: [];
				let series = this.stackedColumnChartOptionBrandTrafficSeriesAndXaxis
					? this.stackedColumnChartOptionBrandTrafficSeriesAndXaxis.data
					: [];
				let max = this.stackedColumnChartOptionBrandTrafficSeriesAndXaxis
					? this.stackedColumnChartOptionBrandTrafficSeriesAndXaxis.max
					: 1;
				stackedColumnChartOptionBrandTraffic.chartOptions.xaxis.categories =
					xaxis.length > 0
						? xaxis.map((xdate) =>
								xdate.substring(0, 7).split("-").reverse().join("/")
						  )
						: [];
				let today = new Date(Date.now());
				if (
					stackedColumnChartOptionBrandTraffic.chartOptions.xaxis.categories
						.length > 0 &&
					today.getFullYear() ==
						stackedColumnChartOptionBrandTraffic.chartOptions.xaxis.categories[
							stackedColumnChartOptionBrandTraffic.chartOptions.xaxis.categories
								.length - 1
						].substring(3, 7) &&
					today.getMonth() ==
						parseInt(
							stackedColumnChartOptionBrandTraffic.chartOptions.xaxis.categories[
								stackedColumnChartOptionBrandTraffic.chartOptions.xaxis
									.categories.length - 1
							].substring(0, 2)
						) -
							1
				) {
					stackedColumnChartOptionBrandTraffic.chartOptions.xaxis.categories[
						stackedColumnChartOptionBrandTraffic.chartOptions.xaxis.categories
							.length - 1
					] =
						stackedColumnChartOptionBrandTraffic.chartOptions.xaxis.categories[
							stackedColumnChartOptionBrandTraffic.chartOptions.xaxis.categories
								.length - 1
						] + " (en cours)";
				}
				stackedColumnChartOptionBrandTraffic.series = series;
				stackedColumnChartOptionBrandTraffic.chartOptions.yaxis.max = max;
				this.stackedColumnChartOptionBrandTraffic =
					stackedColumnChartOptionBrandTraffic;

				resolve(true);
				console.timeEnd("setStackedBarChartOptionsBrandTraffic");
				// })
			});
		},

		setStackedBarChartOptionsTopKeywordsCompetitorsComparison() {
			return new Promise((resolve) => {
				console.time(
					"setStackedBarChartOptionsTopKeywordsCompetitorsComparison"
				);
				/*
				 * //console.log("setStackedBarChartOptionsTopKeywordsCompetitorsComparison BEGIN")
				 * MAKE COPY OF DEFAULT OPTIONS
				 */
				let stackedBarChartOptionsTopKeywordsCompetitorsComparison = {
					series: [],
					chartOptions: {
						chart: {
							type: "bar",
							height: 350,
							stacked: true,
							toolbar: {
								show: false,
							},
							zoom: {
								enabled: false,
							},
							/*
							 * events: {
							 *   click: (event, chartContext, config) => {
							 *     this.displayTopKeywordListPopup(config.config.xaxis.categories[config.dataPointIndex].substring(3,7), config.config.xaxis.categories[config.dataPointIndex].substring(0,2))
							 *   }
							 * }
							 */
						},
						dataLabels: {
							enabled: true,
							enabledOnSeries: true,
							formatter: function (val) {
								return val;
							},
							textAnchor: "middle",
							distributed: false,
							offsetX: 0,
							offsetY: -5,
							style: {
								colors: ["#000", "#FFF", "#FFF", "#FFF", "#FFF", "#FFF"],
							},
						},
						plotOptions: {
							bar: {
								borderRadius: 8,
								horizontal: false,
							},
						},
						xaxis: {
							categories: [],
						},
						yaxis: {
							max: 1,
							title: {
								text: "Nombre de Top Keywords",
								rotate: 270,
								offsetX: 0,
								offsetY: 0,
							},
						},
						tooltip: {
							shared: true,
							intersect: false,
							inverseOrder: true,
						},
						legend: {
							position: "bottom",
							onItemClick: {
								toggleDataSeries: false,
							},
							offsetY: 5,
							inverseOrder: true,
						},
						fill: {
							opacity: 1,
						},
						colors: this.colorsStackCompetitors,
					},
				};

				// SET SERIES
				let [xaxis, series, max, date] =
					this.buildStackedColumnChartSeriesAndXaxisCompetitorComparison();
				console.timeEnd(
					"buildStackedColumnChartSeriesAndXaxisCompetitorComparison END"
				);
				stackedBarChartOptionsTopKeywordsCompetitorsComparison.chartOptions.xaxis.categories =
					xaxis;
				stackedBarChartOptionsTopKeywordsCompetitorsComparison.series = series;
				stackedBarChartOptionsTopKeywordsCompetitorsComparison.chartOptions.yaxis.max =
					max;
				stackedBarChartOptionsTopKeywordsCompetitorsComparison.date =
					" - au " + date;

				this.stackedBarChartOptionsTopKeywordsCompetitorsComparison =
					stackedBarChartOptionsTopKeywordsCompetitorsComparison;
				this.setPerfDataChart().then(() => {
					console.timeEnd(
						"setStackedBarChartOptionsTopKeywordsCompetitorsComparison RESOLVE"
					);
					resolve(true);
				});
				console.timeEnd(
					"setStackedBarChartOptionsTopKeywordsCompetitorsComparison END"
				);
				console.timeEnd(
					"setStackedBarChartOptionsTopKeywordsCompetitorsComparison"
				);
			});
		},

		setStackedBarChartOptionsKeywords() {
			return new Promise((resolve) => {
				let stackedColumnChartOptionKeywords = {
					series: [],
					chartOptions: {
						chart: {
							type: "bar",
							height: 350,
							stacked: true,
							toolbar: {
								show: false,
							},
							zoom: {
								enabled: false,
							},
							events: {
								click: (event, chartContext, config) => {
									this.displayKeywordListPopup(
										config.config.xaxis.categories[
											config.dataPointIndex
										].substring(3, 7),
										config.config.xaxis.categories[
											config.dataPointIndex
										].substring(0, 2)
									);
								},
							},
						},
						dataLabels: {
							enabled: true,
							enabledOnSeries: true,
							formatter: function (val) {
								return val
									? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0")
									: 0;
							},
							textAnchor: "middle",
							distributed: false,
							offsetX: 0,
							offsetY: -5,
							style: {
								colors: ["#000", "#FFF", "#FFF", "#FFF", "#FFF", "#FFF"],
							},
						},
						plotOptions: {
							bar: {
								borderRadius: 8,
								horizontal: false,
							},
						},
						xaxis: {
							categories: [],
						},
						yaxis: {
							max: 1,
							title: {
								text: "Nombre de Keywords",
								rotate: 270,
								offsetX: 0,
								offsetY: 0,
							},
						},
						tooltip: {
							shared: true,
							intersect: false,
							inverseOrder: true,
						},
						legend: {
							position: "bottom",
							onItemClick: {
								toggleDataSeries: false,
							},
							offsetY: 5,
							inverseOrder: true,
						},
						fill: {
							opacity: 1,
						},
						colors: this.colorsStack,
					},
				};
				// SET SERIES
				let [xaxisKeyword, seriesKeyword, max_yaxis] =
					this.buildStackedColumnChartSeriesAndXaxisKeywords(
						this.fromDate,
						this.toDate
					);

				stackedColumnChartOptionKeywords.chartOptions.xaxis.categories =
					xaxisKeyword
						? xaxisKeyword.map((xdate) =>
								xdate.substring(0, 7).split("-").reverse().join("/")
						  )
						: [];
				let today = new Date(Date.now());
				if (
					stackedColumnChartOptionKeywords.chartOptions.xaxis.categories
						.length > 0 &&
					today.getFullYear() ==
						parseInt(
							stackedColumnChartOptionKeywords.chartOptions.xaxis.categories[
								stackedColumnChartOptionKeywords.chartOptions.xaxis.categories
									.length - 1
							].substring(3, 7)
						) &&
					today.getMonth() ==
						parseInt(
							stackedColumnChartOptionKeywords.chartOptions.xaxis.categories[
								stackedColumnChartOptionKeywords.chartOptions.xaxis.categories
									.length - 1
							].substring(0, 2)
						) -
							1
				) {
					stackedColumnChartOptionKeywords.chartOptions.xaxis.categories[
						stackedColumnChartOptionKeywords.chartOptions.xaxis.categories
							.length - 1
					] =
						stackedColumnChartOptionKeywords.chartOptions.xaxis.categories[
							stackedColumnChartOptionKeywords.chartOptions.xaxis.categories
								.length - 1
						] + " (en cours)";
				}
				stackedColumnChartOptionKeywords.series = seriesKeyword;
				stackedColumnChartOptionKeywords.chartOptions.yaxis.max = max_yaxis;

				this.stackedColumnChartOptionKeywords =
					stackedColumnChartOptionKeywords;
				resolve(true);
			});
		},

		setTopKeywordsHistDataOptions() {
			return new Promise((resolve) => {
				console.time("setTopKeywordsHistDataOptions");
				// SET SERIES
				this.buildTopKeywordsHistDataSeriesAndXaxis().then((result) => {
					let xaxis = result[0] == undefined ? [] : result[0];
					let series = result[1] == undefined ? [] : result[1];
					let fillColors = [];
					for (let url of xaxis) {
						let urlIndex = this.competitors.findIndex(
							(competitor) => competitor == url
						);
						if (urlIndex >= 0) {
							fillColors.push(this.competitorsColor[urlIndex]);
						} else {
							fillColors.push(this.colors[0]);
						}
					}
					let barColumnChartOption = {
						tooltip: {
							y: {
								formatter: function (val) {
									return Math.floor(val) + " €";
								},
							},
						},
						colors: fillColors,
						series: [
							{
								name: "Valeur du SEO",
								data: series,
							},
						],
						chart: {
							height: 350,
							type: "bar",
							toolbar: { show: false },
						},
						plotOptions: {
							bar: {
								borderRadius: 10,
								dataLabels: {
									position: "top",
								},
								distributed: true,
							},
						},
						dataLabels: {
							enabled: true,
							formatter: function (val) {
								return val
									? Math.floor(val)
											.toString()
											.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0") + " €"
									: "0 €";
							},
							offsetY: -20,
							style: {
								fontSize: "12px",
								colors: ["#304758"],
							},
						},
						legend: {
							show: false,
						},

						xaxis: {
							labels: {
								formatter: function (url) {
									let urlParts = url.length > 0 ? url.split(".") : [];
									if (urlParts.length >= 2) {
										return urlParts[urlParts.length - 2];
									} else {
										return url;
									}
								},
							},
							categories: xaxis,

							position: "bottom",
							axisBorder: {
								show: false,
							},
							axisTicks: {
								show: false,
							},
							crosshairs: {
								fill: {
									type: "gradient",
									gradient: {
										colorFrom: "#D8E3F0",
										colorTo: "#BED1E6",
										stops: [0, 100],
										opacityFrom: 0.4,
										opacityTo: 0.5,
									},
								},
							},
							tooltip: {
								enabled: true,
							},
						},
						yaxis: {
							axisBorder: {
								show: false,
							},
							axisTicks: {
								show: false,
							},
							labels: {
								show: false,
							},
						},
					};

					this.topKeywordsSEOValue = [];
					if (xaxis.length > 0) {
						for (let i = 0; i < xaxis.length; i++) {
							this.topKeywordsSEOValue.push({
								website: xaxis[i],
								value: series[i],
							});
						}
					}
					this.topKeywordsSEOValueOptions = barColumnChartOption;
					console.timeEnd("setTopKeywordsHistDataOptions");
					resolve(barColumnChartOption);
				});
			});
		},

		setBrandsPages() {
			return new Promise((resolve) => {
				console.time("setBrandsPages");
				let brandPageDataRows = [];
				// let dates = this.makeDateXaxis()//GET MONTHS XAXIS ->
				let startYear = this.fromDate.substring(0, 4);
				let toYear = this.toDate.substring(0, 4);
				let startMonth = this.fromDate.substring(5, 7);
				let toMonth = this.toDate.substring(5, 7);
				// //console.log("this.brandsPagesData",this.brandsPagesData)
				this.brandsPagesData.forEach((row) => {
					// GET YEAR
					let pageData = JSON.parse(row.data);
					if (row.year >= startYear && row.year <= toYear) {
						for (let monthData in pageData) {
							if (
								(row.year == startYear &&
									startYear != toYear &&
									parseInt(monthData) + 1 >= parseInt(startMonth)) ||
								(row.year == startYear &&
									startYear == toYear &&
									parseInt(monthData) + 1 >= parseInt(startMonth) &&
									parseInt(monthData) + 1 <= parseInt(toMonth)) ||
								(row.year == toYear &&
									startYear != toYear &&
									parseInt(monthData) + 1 <= parseInt(toMonth)) ||
								(row.year > startYear && row.year < toYear)
							) {
								for (let url of pageData[monthData]) {
									let foundIndex = brandPageDataRows.findIndex(
										(rowData) => rowData.keys[0] == url.keyword
									);
									if (brandPageDataRows.length > 0 && foundIndex >= 0) {
										brandPageDataRows[foundIndex].clicks += url.clicks;
										brandPageDataRows[foundIndex].impressions +=
											url.impressions;
									} else {
										brandPageDataRows.push({
											clicks: url.clicks,
											impressions: url.impressions,
											keys: [url.keyword],
										});
									}
								}
							}
						}
					}
				});
				// //console.log("brandPageDataRows",brandPageDataRows)
				for (let brandPage of brandPageDataRows) {
					let foundPageRankData = this.pageRankData.findIndex(
						(page) => page.keys[0] == brandPage.keys[0]
					);
					if (foundPageRankData >= 0) {
						brandPage.totalClicks = this.pageRankData[foundPageRankData].clicks;
						brandPage.totalImpressions =
							this.pageRankData[foundPageRankData].impressions;
					} else {
						brandPage.totalClicks = 0;
						brandPage.totalImpressions = 0;
					}
				}

				let filteredBrandPageDataRows = brandPageDataRows.map((row) => {
					if (row.clicks > 0) {
						return row;
					}
				});
				filteredBrandPageDataRows = filteredBrandPageDataRows.filter((row) => {
					if (row) {
						return row;
					}
				});
				// //console.log("filteredBrandPageDataRows",filteredBrandPageDataRows)
				filteredBrandPageDataRows.sort((a, b) => {
					// Use toUpperCase() to ignore character casing
					const keywordA = a.clicks;
					const keywordB = b.clicks;

					let comparison = 0;
					if (keywordA < keywordB) {
						comparison = 1;
					} else if (keywordA > keywordB) {
						comparison = -1;
					}
					return comparison;
				});

				this.brandPageRankData = filteredBrandPageDataRows;
				let sum = 0;
				for (let i = 0; i < this.brandPageRankData.length; i++) {
					sum = sum + this.brandPageRankData[i].clicks;
				}
				this.globalSiteDataKeywords.clicks = sum;
				//console.log("SUM", sum);
				console.timeEnd("setBrandsPages");
				resolve(brandPageDataRows);
			});
		},

		setPerfDataChart() {
			// OPTIONNAL
			return new Promise((resolve) => {
				console.time("setPerfDataChart");
				let dates = this.makeDateXaxis();
				let chartParamKeywords = {
					keys: { data: [], name: "key" },
					keywords: { data: [], name: "Nombre de Top Keywords" },
					seo: { data: [], name: "Valeur du SEO" },
				};

				console.time("setPerfDataChart date");
				let keywordNumberData = [];
				for (let i = 0; i < dates.length; i++) {
					keywordNumberData.push(0);
				}
				console.timeEnd("setPerfDataChart date");

				console.time("setPerfDataChart serieIteratorList");
				let serieIteratorList = [
					...this.stackedColumnChartOptionTopKeywords.series,
				];
				serieIteratorList.shift();
				for (let serie of serieIteratorList) {
					for (let key in serie.data) {
						keywordNumberData[key] += serie.data[key];
					}
				}
				console.timeEnd("setPerfDataChart serieIteratorList");

				console.time("setPerfDataChart keywordNumberData.map");
				keywordNumberData = keywordNumberData.map((data) => data.toFixed(2));
				console.timeEnd("setPerfDataChart keywordNumberData.map");

				chartParamKeywords.keywords.data = keywordNumberData;

				let seoValueData = [];
				for (let i = 0; i < dates.length; i++) {
					seoValueData.push(0);
				}

				let splitDatesArray = dates.map((date) => date.split("-")); // CHECK LES DATES ET LEUR ASSIGNEMENT

				console.time("setPerfDataChart getSeoValue");
				let fromDate = dates[0];
				let toDate = dates[dates.length - 1];

				this.$http
					.get(
						this.apiUrl +
							"georanker/getseovalueyearmonth/" +
							this.selectedSociety.id +
							"/" +
							fromDate +
							"/" +
							toDate
					)
					.then((result) => {
						let fetchSEOValues = result.data;

						for (let dateIndex in splitDatesArray) {
							let foundData = fetchSEOValues.findIndex(
								(row) =>
									row.date ==
									splitDatesArray[dateIndex][0] +
										"-" +
										splitDatesArray[dateIndex][1]
							);
							if (foundData >= 0) {
								seoValueData[dateIndex] = fetchSEOValues[foundData].sum_value;
							} else {
								seoValueData[dateIndex] = 0;
							}
						}
						console.timeEnd("setPerfDataChart getSeoValue");

						console.time("setPerfDataChart seoValueData.map");
						seoValueData = seoValueData.map((data) =>
							data > 0 ? data.toFixed(2) : "0"
						);
						chartParamKeywords.seo.data = seoValueData;
						console.timeEnd("setPerfDataChart seoValueData.map");

						let formatedDates = dates.map((date) =>
							date.split("-").reverse().join("/")
						);
						let today = new Date(Date.now());
						if (
							formatedDates.length > 0 &&
							formatedDates[formatedDates.length - 1].substring(3, 7) ==
								today.getFullYear() &&
							parseInt(
								formatedDates[formatedDates.length - 1].substring(0, 2)
							) -
								1 ==
								today.getMonth()
						) {
							formatedDates[formatedDates.length - 1] =
								formatedDates[formatedDates.length - 1] + " (en cours)";
						}
						this.perfDataKeywords = chartParamKeywords;
						console.time("setPerfDataChart setLineAreaChartOptionsV2");
						this.perfDataKeywordsAreaChart = this.setLineAreaChartOptionsV2(
							chartParamKeywords,
							formatedDates,
							"perfDataChartKeywords"
						);
						console.timeEnd("setPerfDataChart setLineAreaChartOptionsV2");
						console.timeEnd("setPerfDataChart");
						resolve(this.perfDataKeywordsAreaChart);
					})
					.catch(() => {});
			});
		},
	},
};
</script>

<style scoped>
.hvr-underline-out {
	color: black;
}
.hvr-underline:hover {
	color: aqua;
	text-decoration: underline;
	cursor: pointer;
}
.td_padding_top_bottom_small {
	padding-top: 2px !important;
	padding-bottom: 2px !important;
}
.pointer {
	cursor: pointer;
}

.txt_align_right {
	text-align: right !important;
}
</style>